<!-- 菁亿项目首页 -->
<template>
  <div
    class="project_center"
    v-loading="loading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0)"
  >
    <!-- 根据项目职务权限不同 => 项目 人选 -->
    <div class="candidates_flex">
      <div @click="leftproject" :class="typeindex == 0 ? 'left_active' : 'left'">
        <span>项目</span>
      </div>
      <div @click="rightcandidates" :class="typeindex == 1 ? 'left_active' : 'left'">
        <span>人选</span>
      </div>
      <!-- <div @click="rightcollection" :class="typeindex == 2 ? 'left_active' : 'left'">
        <span>回款</span>
      </div> -->
    </div>
    <!-- 项目 -->
    <div v-if="typeindex == 0" class="container">
      <!-- 顶部条件筛选 -->
      <el-card class="labelStyle" :body-style="{ padding: '12px 16px' }">
        <el-form label-width="100px">
          <el-form-item label="项目状态：">
            <div class="buttonContent">
              <el-checkbox-button
                label="不限"
                :value="noLimit"
                @change="limitClick()"
              ></el-checkbox-button>
              <el-checkbox-group v-model="queryInfoPro.projectStatus" @change="noLimitClick()">
                <el-checkbox-button
                  v-for="(el, i) in codeData"
                  :key="i + 'only'"
                  :label="el.slice(0, 2)"
                >
                  {{ el }}
                </el-checkbox-button>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="优先级：" style="margin-bottom: 0">
            <radio-select
              :key="2"
              :code.sync="queryInfoPro.priority"
              type-code="009"
              @onChange="
                search()
                queryInfoPro.pageNum = 1
                queryInfoPro.pageSize = 30
              "
            />
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 中间区域 -->
      <div style="margin: 12px 0">
        <div class="enterporise_list_input_add">
          <!-- 数据排序 -->
          <div class="left orderData">
            <div class="upload_time">
              <div class="caretTime" @click="uploadStatusRecommed">推荐日期</div>
              <div class="san">
                <i
                  class="el-icon-caret-top"
                  :class="[
                    queryInfoPro.columnName == 6 && queryInfoPro.order == 0
                      ? 'isActiveTime1'
                      : 'iconColor'
                  ]"
                  @click="uploadStatusRecommed"
                />
                <i
                  class="el-icon-caret-bottom"
                  :class="[
                    queryInfoPro.columnName == 6 && queryInfoPro.order == 1
                      ? 'isActiveTime1'
                      : 'iconColor'
                  ]"
                  @click="uploadStatusRecommed"
                />
              </div>
            </div>
            <div class="upload_time">
              <div class="caretTime" @click="uploadStatusStart">启动日期</div>
              <div class="san">
                <i
                  class="el-icon-caret-top"
                  :class="[
                    queryInfoPro.columnName == 8 && queryInfoPro.order == 0
                      ? 'isActiveTime1'
                      : 'iconColor'
                  ]"
                  @click="uploadStatusStart"
                />
                <i
                  class="el-icon-caret-bottom"
                  :class="[
                    queryInfoPro.columnName == 8 && queryInfoPro.order == 1
                      ? 'isActiveTime1'
                      : 'iconColor'
                  ]"
                  @click="uploadStatusStart"
                />
              </div>
            </div>
            <div class="upload_time">
              <div class="caretTime" @click="uploadStatusUpdate">更新日期</div>
              <div class="san">
                <i
                  class="el-icon-caret-top"
                  :class="[
                    queryInfoPro.columnName == 7 && queryInfoPro.order == 0
                      ? 'isActiveTime1'
                      : 'iconColor'
                  ]"
                  @click="uploadStatusUpdate"
                />
                <i
                  class="el-icon-caret-bottom"
                  :class="[
                    queryInfoPro.columnName == 7 && queryInfoPro.order == 1
                      ? 'isActiveTime1'
                      : 'iconColor'
                  ]"
                  @click="uploadStatusUpdate"
                />
              </div>
            </div>
            <div class="upload_time">
              <div class="caretTime" @click="uploadStatusPerson">推荐人数</div>
              <div class="san">
                <i
                  class="el-icon-caret-top"
                  :class="[
                    queryInfoPro.columnName == 15 && queryInfoPro.order == 0
                      ? 'isActiveTime1'
                      : 'iconColor'
                  ]"
                  @click="uploadStatusPerson"
                />
                <i
                  class="el-icon-caret-bottom"
                  :class="[
                    queryInfoPro.columnName == 15 && queryInfoPro.order == 1
                      ? 'isActiveTime1'
                      : 'iconColor'
                  ]"
                  @click="uploadStatusPerson"
                />
              </div>
            </div>
          </div>
          <!-- 搜索框 -->
          <div class="right">
            <div class="input_new">
              <span style="width: 68px">岗位：</span>
              <el-input
                placeholder="请输入岗位名称"
                v-model="queryInfoPro.recruitmentCorporateName"
                class="input-with-select"
                clearable
                @change="cleanSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    search()
                    queryInfoPro.pageNum = 1
                    queryInfoPro.pageSize = 10
                  "
                />
              </el-input>
            </div>
            <div class="input_new">
              <span style="width: 68px">企业：</span>
              <el-input
                placeholder="请输入企业名称"
                v-model="queryInfoPro.companyCorporateName"
                class="input-with-select"
                clearable
                @change="cleanSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    search()
                    queryInfoPro.pageNum = 1
                    queryInfoPro.pageSize = 10
                  "
                />
              </el-input>
            </div>
            <el-button type="primary" class="add_enterprise" @click="addProjectDialog"
              >新增项目</el-button
            >
            <el-dropdown
              placement="bottom-end"
              style="margin-left: 20px"
              @command="distributionUsersClick"
              @click.native="isCheckProject"
              :disabled="allDisabled"
            >
              <el-button type="primary">
                批量发布
                <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="all">全量发布</el-dropdown-item>
                <el-dropdown-item command="specify">指定发布</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- 内容区域-项目列表 -->
      <div class="page_nation">
        <!-- 新增的表格 -->
        <div
          style="margin-top: 12px"
          class="JingyiProject"
          ref="checked"
          v-for="(item, index) in jingyiProjectData"
          :key="index"
          :class="{
            active: item.isSelected
          }"
          @click="clickAddActive(item, index)"
        >
          <!-- 编号 -->
          <div class="number">{{ item.uniqueId }}</div>
          <div class="projectItem">
            <div class="proLeft">
              <div class="left_title left_title1" v-if="item.projectSchedule == '立项'">
                {{ item.projectSchedule }}
              </div>
              <div class="left_title left_title2" v-if="item.projectSchedule == '人才mapping'">
                {{ item.projectSchedule }}
              </div>
              <div class="left_title left_title3" v-if="item.projectSchedule == '人才推荐'">
                {{ item.projectSchedule }}
              </div>
              <div class="left_title left_title4" v-if="item.projectSchedule == '面试邀约'">
                {{ item.projectSchedule }}
              </div>
              <div class="left_title left_title5" v-if="item.projectSchedule == 'offer谈判'">
                {{ item.projectSchedule }}
              </div>
              <div class="left_title left_title6" v-if="item.projectSchedule == 'offer接受'">
                {{ item.projectSchedule }}
              </div>
              <div class="left_title left_title7" v-if="item.projectSchedule == '入职'">
                {{ item.projectSchedule }}
              </div>
              <div class="left_title left_title8" v-if="item.projectSchedule == '保证期结束'">
                {{ item.projectSchedule }}
              </div>
              <div class="left_title left_title9" v-if="item.projectSchedule == '冻结'">
                {{ item.projectSchedule }}
              </div>
              <div class="left_l">
                <div class="l_top">
                  <div class="t_left" style="width: 180px">
                    <h3 class="projectName">
                      <!-- {{ item.recruitmentPosition }} -->
                      <el-popover
                        placement="bottom-start"
                        width="200"
                        trigger="hover"
                        :content="item.recruitmentPosition"
                      >
                        <span
                          v-if="item.recruitmentPosition"
                          class="projectName"
                          slot="reference"
                          @click.stop="editProject(item)"
                          >{{ item.recruitmentPosition }}</span
                        >
                      </el-popover>
                    </h3>
                    <span class="recommendDate" v-if="item.recommendDate"
                      >最近推荐时间：{{ item.recommendDate }}</span
                    >
                  </div>
                  <div class="t_right">
                    <img :src="item.companyLogo" alt="" />
                    <div class="dis">
                      <span>{{ item.corporateName }}</span>
                      <span>
                        <span>{{ item.companyProvince }}</span>
                        <span v-if="item.companyCity">-</span>
                        <span>{{ item.companyCity }}</span>
                      </span>
                    </div>
                    <div class="tag tag2" v-if="item.projectType == 0">内</div>
                    <div class="tag tag1" v-if="item.projectType == 1">外</div>
                  </div>
                </div>
                <div class="l_bom">
                  <div>
                    推荐人数
                    <span>|</span>
                    {{ item.recommendNumber ? item.recommendNumber : 0 }}
                  </div>
                  <div>
                    面试人数
                    <span>|</span>
                    {{ item.interviewNumber ? item.interviewNumber : 0 }}
                  </div>
                  <div>
                    offer人数
                    <span>|</span>
                    {{ item.offerNumber ? item.offerNumber : 0 }}
                  </div>
                  <div>
                    淘汰人数
                    <span>|</span>
                    {{ item.dieOutNumber ? item.dieOutNumber : 0 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="proCenter">
              <div class="projectUser" style="width: 130px">
                <el-popover
                  placement="bottom-start"
                  width="200"
                  trigger="hover"
                  :content="item.projectManager"
                >
                  <span v-if="item.projectManager" class="projectManager" slot="reference"
                    >项目经理：{{ item.projectManager }}</span
                  >
                </el-popover>
                <el-popover
                  placement="bottom-start"
                  width="200"
                  trigger="hover"
                  :content="item.customerManager"
                >
                  <span v-if="item.customerManager" class="customerManager" slot="reference"
                    >客户经理：{{ item.customerManager }}</span
                  >
                </el-popover>
                <!-- <span v-if="item.projectManager" class="projectManager"
                  >项目经理：{{ item.projectManager }}</span
                >
                <span v-if="item.customerManager" class="customerManager"
                  >客户经理：{{ item.customerManager }}</span
                > -->
              </div>
              <div class="first">
                <span>优先级别：</span>
                <div>
                  <dic-select
                    class="mini-select"
                    :code.sync="item.priority"
                    type-code="009"
                    :extraInfo="{ id: item.id, priority: item.priority }"
                    placeholder="请选择"
                    @changeVal="changePriority"
                  />
                </div>
              </div>
              <div class="status">
                <span>状态：</span>
                <div>
                  <dic-select
                    class="mini-select"
                    :code.sync="item.projectStatus"
                    type-code="021"
                    :extraInfo="{ id: item.id, projectStatus: item.projectStatus }"
                    placeholder="请选择"
                    @changeVal="changeProjectStatus"
                  />
                </div>
                <!-- <el-select v-model="item.projectStatus" placeholder="请选择" style="width: 98px">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select> -->
              </div>
            </div>
            <div class="proRight">
              <div class="time">
                <!-- <span
                  >有效期：
                  <span class="tag" ref="projectValidity">{{ timea }}</span>
                </span> -->
                <!--
                  :class="time ? 'red' : 'green'"
                -->
                <span v-if="item.projectValidity"
                  >有效期：<span :class="time(item)">{{ item.projectValidity }}</span></span
                >
                <span v-if="item.updateDayNumber">最近更新时间：{{ item.updateDayNumber }}</span>
              </div>
              <div class="operation">
                <el-button
                  size="medium"
                  style="background: rgba(23, 117, 122, 1); color: #fff"
                  @click.stop="toRecommend(item)"
                  >推荐列表<span>({{ item.cnt }})</span></el-button
                >
                <el-button plain size="medium" @click.stop="toCenter(item)">文档中心</el-button>
                <el-button plain size="medium" @click.stop="setNews(item)">更新进度</el-button>
                <el-button type="text" @click.stop="editProject(item)">编辑</el-button>
                <el-button
                  type="text"
                  style="color: rgba(153, 153, 153, 1)"
                  @click.stop="delProject(item)"
                  >删除</el-button
                >
              </div>
              <div class="time fabu">
                <div class="cirle">
                  <span></span>
                </div>
                <div style="margin-left: 6px">
                  <span>{{ item.publishStr }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 人选 ⭐ -->
    <div v-if="typeindex == 1" class="container">
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="checkTab">
          <el-tab-pane :label="`待审核（${personReviewList[0]}）`" name="first"></el-tab-pane>
          <el-tab-pane :label="`已审核（${personReviewList[1]}）`" name="second"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 表格 -->
      <div style="margin-top: 12px">
        <!-- 表格搜索 -->
        <div class="searchT">
          <div class="ckeckbox_text">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              style="margin-right: 26px"
              >全选</el-checkbox
            >
            <el-button
              plain
              size="medium"
              style="margin: 0 16px 0 26px"
              @click="auditingAll"
              v-if="activeName == 'first'"
              >批量审核通过</el-button
            >
            <span class="person">共{{ persontotal }}位候选人</span>
            <div class="input_new">
              <span style="width: 70px">岗位</span>
              <el-input
                placeholder="请输入岗位名称"
                v-model="personListQueryInfo.post"
                class="input-with-select"
                clearable
                @change="cleanSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    personListSearch()
                    personListQueryInfo.pageNum = 1
                    personListQueryInfo.pageSize = 30
                  "
                />
              </el-input>
            </div>
            <div class="input_new">
              <span style="width: 70px">企业</span>
              <el-input
                placeholder="请输入企业"
                v-model="personListQueryInfo.companyName"
                class="input-with-select"
                clearable
                @change="cleanSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    personListSearch()
                    personListQueryInfo.pageNum = 1
                    personListQueryInfo.pageSize = 30
                  "
                />
              </el-input>
            </div>
            <div class="input_new">
              <span style="width: 70px">推荐人</span>
              <el-input
                placeholder="请输入推荐人"
                v-model="personListQueryInfo.referrers"
                class="input-with-select"
                clearable
                @change="cleanSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    personListSearch()
                    personListQueryInfo.pageNum = 1
                    personListQueryInfo.pageSize = 30
                  "
                />
              </el-input>
            </div>
          </div>
        </div>
        <div class="table" v-for="(item, index) in personList" :key="index + 'only'">
          <div class="table_item">
            <!-- 多选框 -->
            <div class="item_checkbox">
              <el-checkbox
                @change="latechange($event, item)"
                v-model="item.checked1"
                label=""
              ></el-checkbox>
            </div>
            <!-- 每一项 -->
            <div class="item_data">
              <div class="item_top">
                <div class="uniqueId_number">{{ item.uniqueId }}</div>
                <!-- 个人信息 -->
                <div class="infoData" style="width: 22%">
                  <img :src="item.headPortraits" alt="" />
                  <div class="info">
                    <h3 @click="toSeeReport(item)">{{ item.name }}</h3>
                    <div class="schoolInfo">
                      <img
                        src="../../../assets/icons/community-line.png"
                        alt=""
                        style="margin-right: 4px"
                      />
                      <!-- item.personEducational[0].schoolName -->
                      <!-- <span>{{ item.personEducational[0].schoolName }}</span> -->
                      <span>{{ (item.personEducational || {}).schoolName }}</span>
                      <span
                        v-if="
                          (item.personEducational || {}).schoolName &&
                          (item.personEducational || {}).major
                        "
                        >-</span
                      >
                      <span>{{ (item.personEducational || {}).major }}</span>
                      <span
                        v-if="
                          (item.personEducational || {}).education &&
                          (item.personEducational || {}).major
                        "
                        >-</span
                      >
                      <span>{{ (item.personEducational || {}).education }}</span>
                    </div>
                    <!-- <div class="experienceInfo">
                      <span>{{ item.workPost }}</span>
                      <span v-if="item.workingYears"> | </span>
                      <span>{{ item.workingYears }}</span>
                      <span v-if="item.workingYears && item.personProvince"> | </span>
                      <span>{{ item.personProvince }}</span>
                      <span v-if="item.personCity && item.personProvince"> - </span>
                      <span>{{ item.personCity }}</span>
                    </div> -->
                  </div>
                </div>

                <!-- 进度 -->
                <div class="center" style="width: 26%">
                  <div class="timeline_box" v-if="item.personExperience">
                    <el-timeline :reverse="true">
                      <el-timeline-item
                        v-for="(items, index) in item.personExperience"
                        :key="index + 10"
                        v-show="index < 3"
                      >
                        <span style="color: #808080; margin-right: 5px" class="endTimeStyle">
                          {{ items.inductionTime }}
                          -
                          <span v-if="items.quitTime !== '1999'">{{ items.quitTime }}</span>
                          <span v-else style="color: #999999">至今</span></span
                        >
                        <span style="color: #1a1f33; margin-right: 5px" v-if="items.companyName">{{
                          items.companyName
                        }}</span>
                        <span style="color: #1a1f33; margin-right: 5px" v-if="items.position">{{
                          items.position
                        }}</span>
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div>

                <!-- 状态 -->
                <div class="status" style="width: 10%">
                  <div class="y" v-if="item.reviewStatus == 1">
                    <img src="../../../assets/images/yes1.png" alt="" />
                  </div>
                  <div class="n" v-if="item.reviewStatus == 2">
                    <img src="../../../assets/images/no1.png" alt="" />
                    <span>{{ item.rejectionReason }}</span>
                  </div>
                </div>

                <!-- 操作 -->
                <div class="proRight" style="width: 36%">
                  <div class="operation">
                    <el-button
                      v-if="activeName == 'first'"
                      size="medium"
                      style="background: rgba(23, 117, 122, 1); color: #fff"
                      @click="agreePerson(item)"
                      >审核通过</el-button
                    >
                    <el-button
                      plain
                      size="medium"
                      @click="auditingNo(item)"
                      v-if="activeName == 'first'"
                      >审核不通过</el-button
                    >
                    <el-button type="text" @click="toSeeReport(item)" v-if="activeName == 'first'"
                      >推荐报告</el-button
                    >
                    <el-button
                      type="text"
                      @click="toSeeRemmReport(item)"
                      v-if="activeName != 'first'"
                      >推荐报告</el-button
                    >
                    <!-- <el-button type="text" style="color: rgba(153, 153, 153, 1)">删除</el-button> -->
                  </div>
                  <div class="time">
                    <span class="person" v-if="item.referrers"
                      >推荐人：
                      <span class="tag" ref="projectValidity">{{ item.referrers }}</span>
                    </span>
                    <span v-if="item.referrersTime"
                      >推荐时间：<span>{{ item.referrersTime }}</span></span
                    >
                  </div>
                </div>
              </div>
              <!-- 下 -->
              <div class="item_bom">
                <div class="company" v-if="item.referrersCompany">
                  <span>推荐企业：</span>
                  <div class="tip">
                    <img src="../../../assets/images/Group 1000001233.png" alt="" />{{
                      item.referrersCompany
                    }}
                  </div>
                </div>
                <div class="job" v-if="item.referrersPost">
                  <span>推荐职位：</span>
                  <div class="tip">
                    <img src="../../../assets/images/Group 1000001234.png" alt="" />{{
                      item.referrersPost
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="typeindex == 11" class="container">
      <!-- 顶部条件筛选 -->
      <!-- <el-card class="labelStyle">
        <el-form label-width="100px">
          <el-form-item label="人选状态：">
            <radio-select
              :key="6"
              :code.sync="query.candidateStatus"
              type-code="022"
              @onChange="selectPersonChosen()"
            />
            <div class="openClose">
              <div class="openInfo">
                <el-radio-group v-model="query.candidateStatus" @change="changeCandidateStatus">
                  <el-radio-button label>不限</el-radio-button>
                  <el-radio-button
                    v-for="(item, index) in candidatesData"
                    :key="index + 'only'"
                    :label="String(index + 1)"
                  >
                    {{ item }}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="推荐时间：">
            <radio-select
              :key="7"
              :code.sync="query.recommendedTime"
              type-code="019"
              @onChange="selectPersonChosen()"
            />
          </el-form-item>
          <el-form-item label="更新时间：">
            <radio-select
              :key="8"
              :code.sync="query.updateTime"
              type-code="019"
              @onChange="selectPersonChosen()"
            />
          </el-form-item>
        </el-form>
      </el-card> -->
      <!-- 中间区域 -->
      <div style="margin: 20px 0">
        <div class="enterporise_list_input_add">
          <div class="left">
            <div class="project_manager_search" v-if="roleIdShow">
              <div class="project_manager">
                <span>项目经理</span>
              </div>
              <el-select
                v-model="projectManagerValue"
                @change="changeProjectManager"
                filterable
                placeholder="请选择"
                @clear="clearItem"
              >
                <el-option
                  v-for="item in projectManagerList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="right">
            <div class="input_new">
              <el-input
                placeholder="请输入企业名称"
                v-model="query.companyCorporateName"
                class="input-with-select"
                clearable
                @change="cleanQuerySearch"
              >
                <!-- <el-button slot="append" icon="el-icon-search" @click="selectPersonChosen()" /> -->
              </el-input>
            </div>
            <div class="input_new">
              <el-input
                placeholder="请输入职位名称"
                v-model="query.recruitmentCorporateName"
                class="input-with-select"
                clearable
                @change="cleanQuerySearch"
              >
                <!-- <el-button slot="append" icon="el-icon-search" @click="selectPersonChosen()" /> -->
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容区域-项目列表 -->
      <div class="page_nation" height="“">
        <div>
          <el-table
            ref="multipleTable"
            height="450"
            :data="personTable"
            :header-cell-style="{ background: '#fff', color: '#1A1F33' }"
            tooltip-effect="dark"
            style="width: 100%"
            @sort-change="changeTableSorts"
          >
            <el-table-column label="人选" width="120px" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a"> {{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="企业" prop="10" sortable="custom" width="130px" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a"> {{ scope.row.corporateName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="岗位" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a">{{ scope.row.recruitmentPosition }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              prop="11"
              sortable="custom"
              min-width="90px"
              align="center"
            >
              <template slot-scope="scope">
                <!-- <span  v-if="scope.row.candidateStatus=='1'">待回复</span>
              <span  v-if="scope.row.candidateStatus=='2'">初试</span>
              <span  v-if="scope.row.candidateStatus=='3'">复试</span>
              <span v-if="scope.row.candidateStatus=='4'">offer</span>
              <span  v-if="scope.row.candidateStatus=='5'">待入职</span>
              <span  v-if="scope.row.candidateStatus=='6'">保证期</span>
              <span v-if="scope.row.candidateStatus=='7'">淘汰</span> -->
                <span class="block_flex"></span>
                <span>{{ scope.row.candidateStatus }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="推荐日期"
              align="center"
              sortable="custom"
              prop="1"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.recommendDate }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="最近联系时间"
              align="center"
              sortable="custom"
              prop="2"
              min-width="140px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.updateDayNumber }}</div>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center" min-width="340px">
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.candidateRemarks }}</span> -->
                <el-tooltip placement="bottom" effect="light">
                  <div class="candidateRemarks" slot="content">
                    {{ scope.row.candidateRemarks }}
                  </div>
                  <el-button
                    v-if="scope.row.candidateRemarks"
                    type="text"
                    class="candidateRemarks_txt"
                    >{{ scope.row.candidateRemarks }}</el-button
                  >
                </el-tooltip>
                <div v-if="positionType.indexOf('2') != -1" @click="addcandidate(scope.row)">
                  <span v-if="!scope.row.candidateRemarks" style="color: #17757a; cursor: pointer"
                    >添加</span
                  >
                  <span v-if="scope.row.candidateRemarks" style="color: #17757a; cursor: pointer"
                    >修改</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div v-if="typeindex == 2" class="container">
      <!-- 顶部条件筛选 -->
      <!-- <el-card class="labelStyle">
        <el-form label-width="100px">
          <el-form-item label="收款状态：">
            <radio-select
              :key="6"
              :code.sync="query.candidateStatus"
              type-code="022"
              @onChange="selectPersonChosen()"
            />
          </el-form-item>

          <el-form-item label="开发票：">
            <radio-select
              :key="7"
              :code.sync="query.recommendedTime"
              type-code="019"
              @onChange="selectPersonChosen()"
            />
          </el-form-item>
        </el-form>
      </el-card> -->
      <!-- 中间区域 -->
      <div style="margin: 20px 0">
        <div class="enterporise_list_input_add">
          <div class="left"></div>
          <div class="right">
            <div class="input_new">
              <el-input
                placeholder="请输入企业、职位名称"
                v-model="query.corporateName"
                class="input-with-select"
                clearable
              >
                <!-- <el-button slot="append" icon="el-icon-search" @click="selectPersonChosen()" /> -->
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容区域-项目列表 -->
      <div class="page_nation">
        <div>
          <el-table
            ref="multipleTable"
            height="450"
            :data="personTable"
            :header-cell-style="{ background: '#fff', color: '#1A1F33' }"
            tooltip-effect="dark"
            style="width: 100%"
            @sort-change="changeTableSorts"
          >
            <el-table-column label="企业" prop="10" sortable="custom" width="120px" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a"> {{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="岗位" width="130px" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a"> {{ scope.row.corporateName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="人选" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a">{{ scope.row.recruitmentPosition }}</span>
              </template>
            </el-table-column>
            <el-table-column label="收款金额" min-width="90px" align="center">
              <template slot-scope="scope">
                <span class="block_flex"></span>
                <span>{{ scope.row.candidateStatus }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="应收日期"
              align="center"
              sortable="custom"
              prop="1"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.recommendDate }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="开票日期"
              align="center"
              sortable="custom"
              prop="1"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.recommendDate }}</div>
              </template>
            </el-table-column>
            <el-table-column label="尾款金额" min-width="90px" align="center">
              <template slot-scope="scope">
                <span class="block_flex"></span>
                <span>{{ scope.row.candidateStatus }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="开票日期"
              align="center"
              sortable="custom"
              prop="1"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.recommendDate }}</div>
              </template>
            </el-table-column>
            <el-table-column label="客户经理" align="center" min-width="140px">
              <template slot-scope="scope">
                <div>{{ scope.row.updateDayNumber }}</div>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center" width="340px">
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.candidateRemarks }}</span> -->
                <el-tooltip placement="bottom" effect="light">
                  <div class="candidateRemarks" slot="content">
                    {{ scope.row.candidateRemarks }}
                  </div>
                  <el-button
                    v-if="scope.row.candidateRemarks"
                    type="text"
                    class="candidateRemarks_txt"
                    >{{ scope.row.candidateRemarks }}</el-button
                  >
                </el-tooltip>
                <div v-if="positionType.indexOf('2') != -1" @click="addcandidate(scope.row)">
                  <span v-if="!scope.row.candidateRemarks" style="color: #17757a; cursor: pointer"
                    >添加</span
                  >
                  <span v-if="scope.row.candidateRemarks" style="color: #17757a; cursor: pointer"
                    >修改</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 分页器 ⭐-->
    <div v-if="typeindex == 0" class="pagination">
      <el-pagination
        :current-page="queryInfoPro.pageNum"
        :page-sizes="[10, 30, 60]"
        :page-size="queryInfoPro.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <div v-if="typeindex == 1" class="pagination">
      <el-pagination
        :current-page="personListQueryInfo.pageNum"
        :page-sizes="[10, 30, 60]"
        :page-size="personListQueryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="persontotal"
        @size-change="handleSizeChanges"
        @current-change="handleCurrentChanges"
      />
    </div>
    <!-- 可能是已删除的功能 -->
    <!-- <el-dialog
      ref="addVisible"
      :visible.sync="dialogVisible"
      width="40%"
      @close="handleClose"
      center
    >
      <title-bar slot="title" title="添加目标企业" />
      <div class="search-input" :class="{ 'search-enterprise': isShowEnterprise }">
        <el-input placeholder="请输入关键词" v-model="enterprise" clearable>
          <el-button slot="append" icon="el-icon-search" @click="searchEnterprise" />
        </el-input>
      </div>
      <div v-if="isShowEnterprise" class="enterpriseInfo">
        <div class="left">
          <el-image
            class="companyLogo"
            :src="enterpriseObj.companyKey"
            style="width: 80px; height: 80px"
            fit="fit"
          />
          <div class="info">
            <div class="companyFullName">{{ enterpriseObj.companyFullName }}</div>
            <div class="industry">
              {{ enterpriseObj.industry }}
              <div class="area">
                <span class="line">|</span>
                {{ enterpriseObj.companyCountry }}{{ enterpriseObj.companyProvince
                }}{{ enterpriseObj.companyCity }}
              </div>
            </div>
          </div>
        </div>
        <icon-and-button
          title="添加"
          icon="icon-jr-icon-yes"
          :buttonStyle="{ color: '#17757A' }"
          @handleControl="handleControl"
        />
      </div>

      <div class="hasAddEnterprise">
        <p>已添加的企业</p>
        <div
          v-for="(item, index) in targetEnterpriseList"
          :key="index"
          class="targetEnterprise enterpriseInfo"
        >
          <div class="left">
            <el-image
              class="companyLogo"
              :src="item.companyLogoKey"
              style="width: 80px; height: 80px"
              fit="fit"
            />
            <div class="info">
              <div class="companyFullName">{{ item.companyFullName }}</div>
              <div class="industry">
                {{ item.industry }}
                <div class="area">
                  <span class="line">|</span>
                  {{ item.companyCountry }}{{ item.companyProvince }}{{ item.companyCity }}
                </div>
              </div>
            </div>
          </div>
          <icon-and-button
            title="取消"
            icon="icon-jr-icon-delete"
            :iconStyle="{ color: '#FA5050' }"
            :extraInfo="{ enterpriseId: item.id }"
            @handleControl="handleControl"
          />
        </div>
      </div>
    </el-dialog> -->
    <el-dialog
      title="人选备注"
      :visible.sync="dialogVisibleadd"
      width="30%"
      :before-close="addhandleClose"
    >
      <div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 6 }"
          placeholder="请输入内容"
          v-model="candidateinfo.candidateRemarks"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleadd = false">取 消</el-button>
        <el-button type="primary" @click="updateCandidateRemarks">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加项目弹窗 ⭐ -->
    <el-dialog
      @close="closeAddDialog"
      :visible.sync="addProjectDialogShow"
      width="40%"
      class="add_project_dialog_left"
    >
      <!-- 头部 -->
      <span slot="title" class="dialog-footer">
        <div class="title">
          <div class="line"></div>
          <div class="title_txt">添加项目</div>
        </div>
      </span>
      <!-- 中间内容 -->
      <div class="add_project_form">
        <el-form
          :model="addProjectForm"
          :rules="addProjectRules"
          ref="addProjectForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="项目类型" prop="projectType">
            <el-radio-group v-model="addProjectForm.projectType">
              <el-radio label="0">自营项目</el-radio>
              <el-radio label="1">外部项目</el-radio>
              <el-radio label="2">菁亿项目</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="企业名称" prop="enterpriseName">
            <el-autocomplete
              class="inline-input"
              v-model="addProjectForm.enterpriseName"
              :fetch-suggestions="enterpriseNameQuerySearch"
              placeholder="请输入"
              :trigger-on-focus="false"
              @select="enterpriseNameSelect"
              @input="inputChanged"
              clearable
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="职位名称" prop="recruitmentPosition">
            <el-autocomplete
              class="inline-input"
              v-model="addProjectForm.recruitmentPosition"
              :fetch-suggestions="positionListQuerySearch"
              placeholder="请选择"
              @select="positionSelect"
              @input="inputChanged"
              clearable
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="项目经理" prop="projectManager" class="add_project_manager">
            <el-select v-model="addProjectForm.projectManager" placeholder="请选择" multiple>
              <el-option
                v-for="(item, index) in dialogProjectManagerList"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="岗位名称" prop="recruitmentPosition">
            <el-select v-model="positionId" placeholder="请选择" @change="selectionChanged">
              <el-option
                v-for="(i1, i2) in positionList"
                :key="i2"
                :label="i1.jobTitle"
                :value="i1.id"
              >
              </el-option>
              <div slot="empty" style="color: #c0c4cc; text-align: center; line-height: 40px">
                请先添加职位
              </div>
            </el-select>
          </el-form-item> -->
          <!-- 3月20日删除上传 -->
          <!-- <el-form-item label="上传JD">
            <el-upload
              class="upload-demo"
              action
              :http-request="uploadFile"
              ref="upload"
              :limit="1"
              :file-list="fileList"
              :show-file-list="false"
            >
              <div class="upload_button">上传JD</div>
            </el-upload>
          </el-form-item> -->
        </el-form>
        <!-- 3月20日删除上传 -->
        <!-- <el-tooltip
          class="item"
          effect="dark"
          :content="tag.name"
          placement="top-start"
          v-for="(tag, index) in fileList"
          :key="index"
        >
          <el-tag
            style="margin-right: 10px; display: flex; align-items: center"
            :disable-transitions="false"
            @close="handleCloseUpload(index)"
            closable
            ><span class="tagtext">{{ tag.name }}</span></el-tag
          >
        </el-tooltip> -->
      </div>
      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <div class="button_box">
          <div class="add" @click="addProject">添加</div>
          <div class="cancel" @click="closeAddDialog">取消</div>
        </div>
      </div>
    </el-dialog>
    <!-- 更新进度弹窗 ⭐ -->
    <el-dialog
      @close="closeNewsDialog"
      :visible.sync="setNewsDialogShow"
      width="50%"
      class="add_project_dialog"
    >
      <el-dialog width="30%" :visible.sync="innerVisible" append-to-body>
        <div slot="title" class="inner">
          <div class="inner_title">
            <div class="inner_line"></div>
            <div>添加项目</div>
          </div>
        </div>
        <div>
          <el-form
            :model="projectScheduleIntActiveForm"
            label-width="120px"
            ref="projectScheduleIntActiveFrom"
            :rules="projectScheduleIntActiveRules"
          >
            <el-form-item label="更新进度" prop="newProjectScheduleIntActive">
              <el-select v-model="projectScheduleIntActiveForm.newProjectScheduleIntActive">
                <el-option
                  v-for="(item, index) in newStepList"
                  :key="index"
                  :label="item.name"
                  :value="item.status"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <!-- 底部按钮 -->
        <div slot="footer" class="dialog-footer">
          <div class="button_box">
            <div class="add" @click="saveProjectScheduleIntActive('projectScheduleIntActiveFrom')">
              保存
            </div>
            <div class="cancel" @click="closeProjectScheduleIntActive">取消</div>
          </div>
        </div>
      </el-dialog>
      <!-- 头部 -->
      <span slot="title" class="dialog-footer">
        <div class="title">
          <div class="title_txt">更新进度</div>
        </div>
      </span>
      <div class="newBtn">
        <el-button
          type="primary"
          class="add_enterprise"
          @click="setNewsUpdate"
          v-has-permission="'/projectCenter/saveProject'"
          >+更新进度</el-button
        >
      </div>
      <!-- 中间内容 -->
      <div class="progress_box">
        <div class="progress">
          <el-steps :active="projectScheduleIntActive" align-center>
            <el-step>
              <template slot="title">
                <div class="item">立项</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.projectApprovalTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item mapping">人才mapping</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.talentMappingTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">人才推荐</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.talentRecommendTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">面试邀约</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.interviewInvitationTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">offer谈判</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.offerNegotiationTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">offe接受</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.offerAcceptTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">入职</div>
              </template>

              <template slot="description">
                <div class="time">{{ projectNewsTime.entryTime }}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item have_not_started">保证期结束</div>
              </template>
              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.endGuaranteePeriodTime }}
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>
      </div>
    </el-dialog>
    <!-- 分配菁亿用户框 ⭐ -->
    <div class="addCandidateDialog">
      <el-dialog
        :visible.sync="distributionUsersDialog"
        width="880px"
        @close="distributionHandleClose"
      >
        <span slot="title" class="dialog-footer">
          <div class="head_title">
            <div class="line"></div>
            <div class="txt">分配菁亿用户</div>
          </div>
        </span>
        <div class="addCandidateDialog_main">
          <!-- 搜索 -->
          <div class="search">
            <el-form
              label-position="right"
              label-width="120px"
              :model="sassaListParam"
              style="display: flex"
            >
              <el-form-item label="用户类型：">
                <el-input v-model="sassaListParam.userType" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="用户姓名：">
                <el-input v-model="sassaListParam.name" placeholder="请输入"></el-input>
              </el-form-item>
              <div style="margin-left: 20px" class="search_btn">
                <el-button type="primary" @click="searchUserOrCompany">搜索</el-button>
                <el-button type="primary" @click="resetSearch">重置</el-button>
              </div>
            </el-form>
          </div>
          <!-- 表格 -->
          <div class="addCandidateDialog_main_box">
            <el-table
              ref="multipleTable"
              :data="distributionTableData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection"> </el-table-column>
              <el-table-column label="用户头像" prop="headPortrait">
                <template slot-scope="scope">
                  <img :src="scope.row.headPortrait" alt="" style="width: 40px; height: 40px"
                /></template>
              </el-table-column>
              <el-table-column prop="userType" label="用户类型">
                <template slot-scope="scope">{{
                  scope.row.userType == 1 ? '企业用户' : '个人用户'
                }}</template>
              </el-table-column>
              <el-table-column prop="userType" label="用户名/企业名称" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.userType == 1"> {{ scope.row.companyName }}</span>
                  <span v-else>{{ scope.row.name }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="phone" label="手机号" show-overflow-tooltip> </el-table-column>
            </el-table>
          </div>

          <!-- 表格 -->
          <div class="addCandidateDialog_main_box" v-if="false">
            <!-- 每一项 -->
            <div
              class="addCandidateDialog_main_item"
              v-for="(item, index) in projectTable"
              :key="index"
            >
              <div class="left">
                <!-- 勾选按钮 -->
                <div class="check">
                  <el-checkbox
                    @change="CandidateCheckbox(item, index)"
                    v-model="item.isPitchOn"
                  ></el-checkbox>
                </div>
                <!-- 头像 -->
                <div class="img_box">
                  <img :src="item.headPortraits" alt="" class="img" />
                </div>
                <!-- 信息 -->
                <div class="info">
                  <div class="userName">{{ item.name }}</div>
                  <div
                    class="shool"
                    v-if="item.personEducational && item.personEducational.length != 0"
                  >
                    <i class="el-icon-office-building" style="color: #17757a"></i>
                    <span style="margin-left: 6px"
                      >{{ item.personEducational[0].schoolName }}
                      {{ item.personEducational[0].major }}
                      {{ item.personEducational[0].education }}</span
                    >
                  </div>
                  <div class="else">
                    {{ item.personType }} <span class="else_line"></span> {{ item.workingYears }}
                    <div class="else_line"></div>
                    {{ item.personProvince }}-{{ item.personCity }}
                  </div>
                </div>
              </div>

              <div class="right">
                <!-- 匹配度 -->
                <!-- <div class="matching_rate">
                  匹配度
                  <el-progress
                    :width="16"
                    :show-text="false"
                    :stroke-width="2"
                    type="circle"
                    :percentage="75"
                    style="margin: 0 2px 0 5px"
                    color="#17757a"
                  ></el-progress>
                  75%
                </div> -->

                <!-- 查看详情 -->
                <div class="details">查看详情</div>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="pagination_box">
            <!--匹配信息 -->
            <div class="addCandidateDialog_main_title_right">
              已选<span class="select">{{ disCheckedNum }}</span>
            </div>
            <el-pagination
              @size-change="handleSizeChangeDialog"
              @current-change="handleCurrentChangeDialog"
              :page-sizes="[10, 20, 30, 50]"
              :current-page="1"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalDisUser"
            >
            </el-pagination>
          </div>
          <!-- 操作按钮 -->
          <div class="btn_list">
            <div class="cancel" @click="distributionUsersDialog = false">取消</div>
            <div class="add" @click="distributionUsersFn">确定</div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 审核不通过弹窗 ⭐ -->
    <el-dialog :visible.sync="auditingNoDialogVisible" width="40%" :before-close="handleClose">
      <div class="auditingNo">
        <div class="title"><span></span><span>审核不通过</span></div>
      </div>
      <div style="padding: 50px 50px 0 40px">
        <el-form
          label-position="left"
          label-width="100px"
          :model="auditingNoForm"
          :rules="auditingNoRules"
        >
          <div style="display: flex; margin-bottom: 10px">
            <el-form-item label="驳回理由：" prop="rejectionReason">
              <el-select
                v-model="auditingNoForm.rejectionReason"
                placeholder="请选择"
                @change="rejectionReasonChange"
                clearable
                :disabled="auditingDisabled"
              >
                <el-option v-for="item in options" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-radio-group v-model="info">
                <el-radio
                  :label="1"
                  :disabled="rejectionDisabled"
                  @click.native="pendingRes($event)"
                  >自定义理由</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="驳回理由：" v-if="info == 1">
            <el-input
              v-model="auditingNoForm.rejectionReason"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 20 }"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="auditingNoFn">保 存</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 修改客户经理 - 未使用 -->
    <el-dialog title="修改客户经理" :visible.sync="customerManagerDialogForm">
      <el-form :model="customerManagerForm">
        <el-form-item label="客户经理">
          <el-select v-model="customerManagerForm.manager" multiple placeholder="请选择">
            <el-option
              v-for="(item, index) in customerManagerList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerManagerDialogForm = false">取 消</el-button>
        <el-button type="primary" @click="modifyApiCustomerManager">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import radioSelect from '@/components/RadioSelect.vue'
import {
  projectCenterDeleteById,
  getEnterprise,
  getTargetEnterprise,
  getProjectManager,
  projectShelf,
  updateCandidateRemarks,
  updategetCustomerManager,
  selectUpdateCustomerManager,
  selectProjectCenterNumber,
  selectPersonChosenNumber
} from '@/api/projectCenter.js'
import {
  selectProjectCenterTwov1,
  list,
  publishUser,
  publishAll,
  saveProject,
  updateProjectSchedule,
  selectBYId,
  deleteProject,
  updatePriority,
  updateStatus,
  personList,
  agree,
  reject,
  rejectionType,
  personReview,
  number
} from '@/api/jingyiProject.js'
import { pagination } from '@/mixins/pagination'
import { getCompanyNameList } from '@/api/projectCenter.js'
import { selectPosition } from '@/api/position.js'
import { codeType } from '@/api/common.js'
import DicSelect from '@/components/DicSelect.vue'

const positionType = sessionStorage.getItem('position')
const defaultQuery = Object.freeze({
  candidateStatus: '', //人选状态（1、待回复；2、初试；3、复试；4、offer；5、待入职；6、保证期；7、淘汰）
  columnName: '', //排序字段(1、推荐日期；2、最近联系时间；)
  // corporateName: '', //搜索框(企业、岗位、姓名)
  recruitmentCorporateName: '', //搜索公司名称
  companyCorporateName: '', //搜索公司企业名称
  order: '', //排序（1、升序;2、降序）
  projectManager: '', //项目经理
  recommendedTime: '', //推荐日期（一周；一月；一季度；一年）
  updateTime: '', //最近联系时间（一周；一月；一季度；一年）
  pageNum: 1, //页数
  pageSize: 10 //大小
})
const defaultQueryInfo = Object.freeze({
  projectSchedule: '', // 项目进度
  priority: '', // 优先级
  columnName:
    positionType.indexOf('1') != '-1' ? '13' : positionType.indexOf('2') != '-1' ? '12' : '7', //排序字段
  // corporateName: '', //搜索字段
  recruitmentCorporateName: '', //搜索公司名称
  companyCorporateName: '', //搜索公司企业名称
  order: '0', //排序
  pageNum: 1, //页数
  pageSize: 10, //大小
  size: '', //所选条数
  type: null,
  projectType: '', // 项目类型0->内；1->外
  queryTime: '', //查询时间（一周；一月；一季度；一年）
  projectManager: '', // 项目经理
  activateTime: '', //启动时间（一周；一月；一季度；一年）
  projectStatus: ['紧急', '活跃'], //项目状态：code表021(紧急,活跃,暂缓,暂停,关闭,成功)
  recommendedTime: '' //推荐时间（一周；一月；一季度；一年）
})
const defaultForm = Object.freeze({
  positionType: '', // 职位类型
  dutyStation: '', // 工作地址-详细地址
  isAnnual: null, // 月薪或者年薪0->月薪；1->年薪
  salaryRange: '', // 薪资范围
  jobDescription: '', // 职位描述
  area: '', // 工作地区 地区
  province: '', // 工作省份
  city: '', // 工作城市
  requiredSkills: '', // 所需技能
  companyProfile: '', // 公司简介
  industry: '', // 所属行业
  projectType: '0', // 项目类型
  enterpriseName: '', // 企业名称
  projectManager: '',
  customerManager: sessionStorage.getItem('projectManager'),
  recruitmentPosition: '' //岗位名称
})
const defaultProjectSchedule = Object.freeze({
  name: '项目进度',
  isUpActive: false, //激活'up'样式
  isDownActive: false //激活'down'样式
})
const defaultPriority = Object.freeze({
  name: '优先级',
  isUpActive: false, //激活'up'样式
  isDownActive: false //激活'down'样式
})
const defaultUpdateTime = Object.freeze({
  name: '更新时间',
  isUpActive: false, //激活'up'样式
  isDownActive: false //激活'down'样式
})
const defaultAddProjectForm = Object.freeze({
  area: '', //工作地区
  city: '', //工作城市
  companyCode: '', //企业编号
  companyName: '', //公司简称
  companyProfile: '', //公司简介
  dutyStation: '', //工作地点
  enterpriseName: '', //企业
  industry: '', //所属行业
  isAnnual: '', //月薪或者年薪0->月薪；1->年薪
  jobDescription: '', //职位描述
  positionId: '', //职位id
  positionType: '', //职位类型
  projectBrief: '', //项目一句话
  projectManager: '', //项目经理
  projectType: '', //项目类型0->内；1->外; 2 ->菁亿项目;
  projectValidity: '', //项目有效期
  province: '', //工作省份
  recruitmentPosition: '', //职位
  requiredSkills: '', //所需技能
  salaryRange: '' //薪资范围
})
const defaultPersonListQueryInfo = Object.freeze({
  pageNum: 1, //页数
  pageSize: 10, //大小
  companyName: '', //企业
  post: '', //岗位
  referrers: '', //推荐人
  reviewStatus: null //审核状态：0 待审核 1 审核成功 2 审核失败
})
// 搜索请求参数
const defaultQueryInfoPro = Object.freeze({
  pageNum: 1, //页数
  pageSize: 10, //大小
  activateTime: '', //启动时间（一周；一月；一季度；一年）
  columnName: '15', //页数排序字段(1、人选数；2、推荐数；3、面试数；4、offer数；5、淘汰数；6、最近推荐日期；7:更新时间；8：启动时间；9:优先级（9则type必传009）；10：企业排序；11:项目状态（11则type必传021）；12：客户经理，优先项目状态>更新日期排序（12则type必传021）；13：项目经理，优先优先级>更新日期排序（13则type必传009）；14：职位排序
  companyCorporateName: '', //企业搜索框
  corporateName: '', //搜索框
  customerManager: '', //客户经理
  order: '', //排序(1、降序；0、升序)
  orderType: '', //排序数据
  priority: '', //优先级别
  projectManager: '', //项目经理
  projectSchedule: '', //项目进度
  projectStatus: [], //项目状态：code表021(紧急,活跃,暂缓,暂停,关闭,成功)多个用,隔开
  projectStatusStr: '', //
  projectType: 2, //项目类型0->内；1->外；2->菁亿项目
  queryTime: '', //更新时间（一周；一月；一季度；一年）
  recommendedTime: '', //推荐时间（一周；一月；一季度；一年）
  recruitmentCorporateName: '', //岗位搜索框
  recruitmentPosition: '', //招聘岗位
  type: '' //
})
//菁亿项目-项目数据
const defaultJingyiProjectTable = Object.freeze({
  city: '', //城市
  companyCity: '', //公司城市
  companyLogo: '', //公司logo
  companyLogoKey: '', //
  companyProvince: '', //公司省份
  coreRequirements: '', //核心需求
  corporateName: '', //公司名称
  createTime: '', //启动日期
  customerManager: '', //客户经理
  customerManagers: '', //
  dieOutNumber: '', //淘汰数
  dutyStation: '', //工作地点
  id: '', //主键
  interviewNumber: '', //面试人数
  isShelf: '', //上下架状态
  offerNumber: '', //offer数
  personChosenNumber: '', //人选数
  predictPush: '', //预计首推
  priority: '', //优先级别
  projectManager: '', //项目经理
  projectManagers: '', //
  projectSchedule: '', //项目进度
  projectScheduleInt: null, //项目进度
  projectStatus: '', //项目状态：code表021(紧急,活跃,暂缓,暂停,关闭,成功)
  projectType: '', //项目类型0->内；1->外；2->菁亿项目
  projectValidity: '', //有效期
  recommendDate: '', //最近推荐日期
  recommendNumber: '', //推荐人数
  recruitmentPosition: '', //招聘职位
  salaryRange: '', //薪资范围
  updateDayNumber: '', //最近更新日期
  updateTime: '' //更新时间
})
//菁亿分配用户请求参数
const defaultSassaListParam = Object.freeze({
  pageNum: 1, //页数
  pageSize: 10, //大小
  columnName: '', //排序字段(1、审核状态；2、新增时间
  name: '', //名称 查询企业或姓名
  order: '', //排序(1、降序；0、升序)
  reviewStatus: '', //审核状态：0 未审核 1 已审核 2 全部
  userCity: '', //所在城市
  userCountry: '', //所在国家
  userProvince: '', //所在省份
  userType: '', //用户类型：0 个人用户 1 企业用户
  projectCodes: [] //项目id
})
export default {
  components: {
    radioSelect,
    // DicSort,
    DicSelect
    // multiSelect
  },
  mixins: [pagination],
  data() {
    return {
      allDisabled: false, //批量发布按钮禁用与否
      auditingDisabled: false, //控制驳回理由下拉状态
      rejectionDisabled: false, //控制自定义理由状态
      projectIdList: [], //选中的项目id
      // 移除成功的字段
      removeSucceed: 0,
      idsList: [],
      ids: [],
      checkAll: false, //选择所有
      personReviewList: [], //查询人选的审核数量
      waitAuditingNum: null, //待审核数量
      auditingEndNum: null, //已审核数量
      reviewCode: '', //唯一id
      personListQueryInfo: { ...defaultPersonListQueryInfo }, //人选查询参数
      personList: [], //人选表单数据
      isIndeterminate: false,
      activeName: 'first',
      timea: '2032-02-02', //测试
      queryInfoPro: { ...defaultQueryInfoPro }, //搜索请求参数
      jingyiProjectData: [], //菁亿项目表格数据
      jingyiProjectTable: { ...defaultJingyiProjectTable }, //菁亿项目-项目数据
      setNewsDialogShow: false, //更新进度弹窗显示
      distributionUsersDialog: false, //分配菁亿用户弹窗显示
      sassaListParam: { ...defaultSassaListParam }, //菁亿分配用户查询参数
      totalDisUser: 0, //菁亿分配用户总数
      distributionTableData: [], //菁亿分配用户数据
      disIdList: {
        distributionProjectId: [], //菁亿分配项目id
        distributionUserCode: [] //菁亿分配用户id
      },
      disCheckedNum: 0, //菁亿分配用户已选数量
      disCheckedList: [], //菁亿分配选中的数据，用于清空
      disIdsList: [], //菁亿全量发布id数组
      addProjectDialogShow: false, // 添加项目弹窗
      addProjectForm: { ...defaultAddProjectForm }, //添加项目表单数据
      // 添加项目表单校验
      addProjectRules: {
        projectType: [{ required: true, message: '请选择项目类型', trigger: 'blur' }],
        enterpriseName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        recruitmentPosition: [{ required: true, message: '请输入职位名称', trigger: 'blur' }],
        projectManager: [{ required: true, message: '请选择项目经理', trigger: 'blur' }],
        file: [{ required: true, message: '请上传JD' }]
      },
      // 更新更新进度请求参数
      setNewsForm: {
        projectSchedule: 0, //项目更新进度值（名称）
        projectId: null //项目id
      },
      projectScheduleIntActive: null, //项目更新进度值（名字）
      //项目更新进度时间
      projectNewsTime: {
        projectApprovalTime: '', //立项时间
        talentMappingTime: '', //人才mapping时间
        talentRecommendTime: '', //人才推荐时间
        interviewInvitationTime: '', //面试邀约时间
        offerNegotiationTime: '', //offer谈判时间
        offerAcceptTime: '', //offer接受时间
        entryTime: '', //入职时间
        endGuaranteePeriodTime: '' //保证期结束时间
      },
      statusI: 0, //排序
      auditingNoDialogVisible: false, //审核不通过弹窗显示
      auditingNoForm: {
        rejectionReason: '', //驳回理由
        rejectionType: '', //驳回理由类型（自定义）
        reviewCode: '' //审核编号审核编号
      },
      //审核不通过表单校验
      auditingNoRules: {
        rejectionReason: [{ required: true, message: '请选择驳回理由', trigger: 'change' }]
      },
      options: [], //驳回理由数据
      radio: 0, //驳回理由
      //审核不通过表单数据
      info: 0, //是否显示自定义驳回理由
      // ---------

      typeCode: '021', //查询字符串
      noLimit: ['不限'], //项目状态数组 ⭐
      codeData: [], //项目数据循环
      stateList: [], //项目状态数组
      candidatesCode: '022', // 人选状态字符串
      candidatesData: [], // 人选状态数组循环
      candidatesList: [], //人选状态数组
      personTable: [],
      persontotal: 0, //人选总条数
      query: { ...defaultQuery },
      loading: false,
      roleId: '',
      projectSchedule: { ...defaultProjectSchedule },
      updateTime: { ...defaultPriority },
      priority: { ...defaultUpdateTime },
      order: '', // 顺序
      sortField: '', // 排序名
      roleIdShow: true, //项目经理的显示
      queryInfo: { ...defaultQueryInfo },
      projectTable: [], // 表格数据
      dialogVisible: false, // 弹窗状态
      id: '', // 项目id
      enterprise: '', // 企业查询
      enterpriseObj: {}, // 查询到的企业
      targetEnterpriseList: [], // 目标企业
      isShowEnterprise: false,
      pitchId: '',
      projectManagerList: [], // 查询到的项目经理
      dialogProjectManagerList: [], // 查询到的项目经理
      projectManagerValue: '', //选中的项目经理
      projectManagerValueTwo: '',
      typeindex: 0,
      pitchData: [
        {
          id: '',
          value: '不限'
        },
        {
          id: '0',
          value: '内'
        },
        {
          id: '1',
          value: '外'
        }
      ],
      form: { ...defaultForm }, // 表单数据

      fileList: [], //3月20日删除上传
      enterpriseNameList: [], //查询到的企业名称
      positionId: null, //  选中的职位id
      positionLists: [], // 查询到的职位相关数据
      positionList: [], //查询到的职位名称
      positionType: sessionStorage.getItem('position'),
      dialogVisibleadd: false,
      candidateinfo: {}, //人选备注详情
      currentErpriseName: '', //当前选中的公司名称
      customerManagerForm: {
        manager: [],
        projectId: ''
      },
      customerManagerDialogForm: false, // 打开修改客户经理弹窗
      customerManagerList: [], // 客户经理数据列表
      // 更新进度数据
      newStepList: [
        {
          name: '立项',
          status: 0
        },
        {
          name: '人才mapping',
          status: 1
        },
        {
          name: '人才推荐',
          status: 2
        },
        {
          name: '面试邀约',
          status: 3
        },
        {
          name: 'offer谈判',
          status: 4
        },
        {
          name: 'offe接受',
          status: 5
        },
        {
          name: '入职',
          status: 6
        },
        {
          name: '保证期结束',
          status: 7
        }
      ],
      innerVisible: false, // 弹窗显示
      projectScheduleIntActiveForm: {
        newProjectScheduleIntActive: null
      },
      projectScheduleIntActiveRules: {
        newProjectScheduleIntActive: [
          { required: true, message: '请选择项目更新进度', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    tabType() {
      const type = this.$route.query.tabType||0;
      return type
    },
    getProjectScheduleColor() {
      return function (val) {
        let str = ''
        switch (val) {
          case '前期筹备':
            str = 'color1'
            break
          case '人才mapping':
            str = 'color2'
            break
          case '面试邀约':
            str = 'color3'
            break
          case 'offer谈判':
            str = 'color4'
            break
          case '后续跟进':
            str = 'color5'
            break
          case '已完成':
            str = 'color6'
            break
          case '已结束':
            str = 'color7'
            break
          case '冻结':
            str = 'color8'
            break
          case '保证期结束':
            str = 'color9'
            break
          case '立项':
            str = 'color10'
            break
          case '人才推荐':
            str = 'color11'
            break
          case 'offer接受':
            str = 'color12'
            break
          case '入职':
            str = 'color13'
            break
          default:
            break
        }
        return str
      }
    },
    workbenchHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/projectCenter/selectBYId')
      return hasPermission
    },
    // /projectCenter/deleteById
    deleteHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/projectCenter/deleteById')
      return hasPermission
    }
  },
  created() {
    if(this.tabType==1){

this.typeindex=1;

    }else{

      this.search()
    }
    this.personListSearch()
    this.getRejectionType()
    this.getPersonReview()
    // -----

    // if (Object.keys(this.$store.state.queryInfo).length) {
    //   Object.keys(this.$store.state.queryInfo).forEach((item) => {
    //     this.queryInfo[item] = this.$store.state.queryInfo[item]
    //   })
    // }

    this.roleId = sessionStorage.getItem('roleId')
    let nameEnglish = sessionStorage.getItem('nameEnglish')
    // this.projectManagerValue=nameEnglish
    // this.queryInfo.projectManager = nameEnglish
    // console.log("判断是否是管理员",this.roleId)
    // 如果角色不是超级管理员
    let projectManager = sessionStorage.getItem('projectManager')
    if (!projectManager) {
      //第一次登录缓存中没有projectManager
      if (this.roleId != 1) {
        this.queryInfo.projectManager = nameEnglish
        this.projectManagerValue = nameEnglish
      }
    } else if (projectManager == 'xxx' && projectManager == '') {
      //清空项目经理选项框以后
      this.queryInfo.projectManager = ''
      this.projectManagerValue = ''
    } else if (projectManager != 'xxx' && projectManager != '') {
      //选中项目经理后
      this.queryInfo.projectManager = projectManager
      this.projectManagerValue = projectManager
    }
    this.getProjectManagerList()
    this.getCode(this.typeCode)
  },
  watch: {
    // 监听tabs切换
    activeName: {
      handler(newVal, oldVal) {
        if (newVal == 'first') {
          this.personListQueryInfo.reviewStatus = 0
          this.personListSearch()
        } else if (newVal == 'second') {
          this.personListQueryInfo.reviewStatus = 1
          this.personListSearch()
        }
      },
      immediate: true
    },
    // 监听是否选中项目allDisabled
    projectIdList: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && newVal) {
          if (newVal.length > 0) {
            this.allDisabled = false
          } else {
            this.allDisabled = true
          }
        }
      }
    },
    //监听路由
    // '$route.path': {
    //   handler: function (val, oldVal) {
    //     console.log(val,'val')
    //   },
    //   // 深度观察监听
    //   deep: true
    // }
    $route(to, from) {
      //console.log(from.path, '111')
      //console.log(to.path, '222')
    }
  },
  methods: {
    // 去文档中心
    toCenter(row) {
      const levelItem = {
        companyLogo: row.companyLogo,
        levelItem: row.corporateName,
        id: row.id,
        corporateName: row.corporateName,
        coreRequirements: row.coreRequirements,
        projectScheduleInt: row.projectScheduleInt,
        uniqueId: row.uniqueId
      }
      this.$router.push({
        path: '/businessManagement/archivesCenter',
        query: {
          id: row.id,
          levelItem: JSON.stringify(levelItem),
          item: JSON.stringify(row)
        }
      })
    },
    // 控制驳回理由
    pendingRes(event) {
      if (event.target.tagName === 'INPUT') {
        let id = event.target.value
        if (this.info != id) {
          this.auditingDisabled = true
          this.auditingNoRules.rejectionReason[0].required = false
          this.auditingNoRules.rejectionReason[0].message = ''
        } else {
          this.auditingDisabled = false
          this.auditingNoRules.rejectionReason[0].required = true
          this.auditingNoRules.rejectionReason[0].message = '请选择驳回理由'
          this.info = 0
        }
      }
    },
    //选中审核不通过改变事件
    rejectionReasonChange(val) {
      if (val) {
        this.rejectionDisabled = true
      } else {
        this.rejectionDisabled = false
      }
    },
    // 选中项目
    clickAddActive(item, index) {
      // // 1全量发布 0未全量发布
      // if (item.isPublish == 1) {
      //   this.$message.warning('该项目已经发布')
      //   return
      // }
      this.jingyiProjectData[index].isSelected = !this.jingyiProjectData[index].isSelected
      let projectIdList = []
      this.jingyiProjectData.forEach((item, index) => {
        if (item.isSelected) {
          projectIdList.push(item.id)
        }
      })
      this.projectIdList = projectIdList
      this.isPublishNum = item.isPublish
    },
    //拿到项目id
    getProjectId(item) {
      this.projectIdList.push(item.id)
      // this.projectIdList.forEach((id, index) => {
      //   if (id == item.id) {
      //     this.projectIdList.splice(1, index)
      //   } else {
      //     this.projectIdList.push(id)
      //   }
      // })
    },
    // 有效期颜色控制
    time(item) {
      const now = new Date().getTime()
      const projectValidityNow = new Date(item.projectValidity).getTime()
      if (projectValidityNow < now) {
        return 'red'
      } else {
        return 'green'
      }
    },
    // 批量审核通过
    async auditingAll() {
      const { data: res } = await agree({
        reviewCode: this.ids
      })
      if (res.resultCode == 200) {
        this.ids = []
        this.$message.success('批量审核成功')
        this.isIndeterminate = false
        this.checkAll = false
        this.personListSearch()
        this.getPersonReview()
      }
    },
    // 多选框选中数据
    latechange(bol, row) {
      const index = this.ids.indexOf(row.reviewCode)
      if (index == -1) {
        this.ids.push(row.reviewCode)
        this.idsList.push(row)
      } else {
        this.ids.splice(index, 1)
        this.idsList.splice(index, 1)
      }
    },
    // 多选框选中事件
    handleCheckAllChange(val) {
      if (val) {
        this.personList.forEach((item) => {
          this.ids.push(item.reviewCode)
          this.idsList.push(item)
          this.$set(item, 'checked1', true)
        })
      } else {
        this.personList.forEach((item) => {
          this.ids = []
          this.idsList = []
          this.$set(item, 'checked1', false)
        })
      }
      this.isIndeterminate = val
    },
    // 去查看推荐报告
    toSeeRemmReport(item) {
      this.$router.push({
        path: '/businessManagement/recommendedReport',
        query: {
          item: JSON.stringify(item),
          PreCode: item.personCode,
          id: item.id,
          type: '1',
          reviewCode: item.reviewCode,
          showAutingBtn: 0,
          projectCode: item.projectCode //项目id
        }
      })
    },
    // 查询人选的审核数量
    async getPersonReview() {
      const { data } = await personReview(this.personListQueryInfo)
      if (data.resultCode == 200) {
        this.personReviewList = data.data
      }
    },
    // 人选审核通过
    async agreePerson(item) {
      const { data: res } = await agree({
        reviewCode: [item.reviewCode]
      })
      if (res.resultCode == 200) {
        this.$message.success('审核成功')
        this.personListSearch()
        this.getPersonReview()
      }
    },
    // 待审核，已审核切换
    checkTab(tab, event) {
      if (tab.index == '0') {
        this.personListQueryInfo.reviewStatus = 0
        this.waitAuditingNum = this.persontotal
        this.getPersonReview()
        this.personListSearch()
      } else {
        this.personListQueryInfo.reviewStatus = 1
        this.waitAuditingNum = this.persontotal
        this.personListSearch()
        this.getPersonReview()
      }
    },
    // 人选页面查询
    async personListSearch() {
      const { data } = await personList(this.personListQueryInfo)
      if (data.resultCode == 200) {
        this.personList = data.data.list
        this.personList.forEach((item) => {
          this.$set(item, 'checked1', false)
        })
        this.persontotal = data.data.total
        this.removeSucceed = 1
      }
    },
    // 去查看报告页面
    toSeeReport(item) {
      this.$router.push({
        path: '/businessManagement/recommendedReport',
        query: {
          item: JSON.stringify(item),
          PreCode: item.personCode,
          id: item.id,
          type: '1',
          reviewCode: item.reviewCode,
          showAutingBtn: 0,
          projectCode: item.projectCode, //项目id
          tabType: '1'
        }
      })
    },
    // 查询拒绝理由
    async getRejectionType() {
      const { data } = await rejectionType({
        type: '024'
      })
      if (data.resultCode == 200) {
        this.options = data.data
      }
    },
    // 打开审核不通过弹窗
    auditingNo(item) {
      this.reviewCode = item.reviewCode
      this.auditingNoDialogVisible = true
    },
    // 关闭审核不通过弹窗
    handleClose() {
      this.auditingNoDialogVisible = false
      this.info = 0
      this.auditingDisabled = false
      this.rejectionDisabled = false
      this.auditingNoForm = {
        rejectionReason: '', //驳回理由
        rejectionType: '', //驳回理由类型（自定义）
        reviewCode: '' //审核编号审核编号
      }
      this.auditingNoRules.rejectionReason[0].require = false
      this.personListSearch()
      this.getPersonReview()
    },
    // 审核不通过弹窗保存
    async auditingNoFn() {
      this.auditingNoForm.reviewCode = this.reviewCode
      const { data } = await reject(this.auditingNoForm)
      if (data.resultCode == 200) {
        this.$message.success(data.message)
        this.auditingNoDialogVisible = false
        this.info = 0
        this.auditingDisabled = false
        this.rejectionDisabled = false
        this.auditingNoRules.rejectionReason[0].require = false
        this.auditingNoForm = {
          rejectionReason: '', //驳回理由
          rejectionType: '', //驳回理由类型（自定义）
          reviewCode: '' //审核编号审核编号
        }
        this.personListSearch()
        this.getPersonReview()
      }
    },
    // 添加项目 弹框显示
    addProjectDialog() {
      this.addProjectDialogShow = true
      this.addProjectForm = {}
      // this.currentErpriseName = ''
      // this.positionList = []
    },
    // 添加项目 保存按钮
    addProject() {
      this.$refs.addProjectForm.validate(async (valid) => {
        if (valid) {
          const { data: res } = await saveProject(this.addProjectForm)
          if (res.resultCode == 200) {
            this.$message.success('新增成功')
            this.addProjectForm = {}
            this.addProjectDialogShow = false
            //成功后跳转到新增项目界面
            this.$router.push({
              path: '/businessManagement/editProject',
              query: {
                id: res.data
              }
            })
          } else {
            this.$message.error(res.message)
          }
        } else {
          return false
        }
      })
    },
    search_candidate() {
      // const { data: res } = await getHomePage(this.query)
      // this.addCandidateDialogList = res.data.content
      // console.log("人才数据",res.data.content);
    },
    clear_input(val) {
      // if (!val) {
      //   const { data: res } = await getHomePage(this.query)
      //   this.addCandidateDialogList = res.data.content
      // }
    },
    // 菁亿分配选中改变事件
    handleSelectionChange(val) {
      this.disIdList.distributionProjectId = []
      this.disIdList.distributionUserCode = []
      this.disCheckedList = val
      if (val) {
        this.disCheckedNum = val.length
        val.map((item) => {
          if (item.userType == 1) {
            this.disIdList.distributionProjectId.push(item.userCode)
          }
          if (item.userType == 0) {
            this.disIdList.distributionUserCode.push(item.userCode)
          }
        })
      }
    },
    // 菁亿分配输入框搜索
    searchUserOrCompany() {
      this.distributionSearch()
    },
    // 菁亿分配重置
    resetSearch() {
      this.sassaListParam.name = ''
      this.sassaListParam.userType = ''
      this.distributionSearch()
    },
    // 菁亿分配分页
    handleSizeChangeDialog(val) {
      this.sassaListParam.pageSize = val
      this.distributionSearch()
    },
    handleCurrentChangeDialog(val) {
      this.sassaListParam.pageNum = val
      this.distributionSearch()
    },
    // 菁亿分配勾选
    CandidateCheckbox(item, index) {
      // if (item.isPitchOn == true) {
      //   let query = {
      //     personCode: item.personCode,
      //     projectId: JSON.parse(this.$route.query.item).id * 1
      //   }
      //   // const { data: res } = await selectExist(query)
      //   if (res.data == true) {
      //     this.$message('这条数据已在列表中,请勿重复添加')
      //     return (this.projectTable[index].isPitchOn = false)
      //   }
      // }
      // this.selectSum = 0
      // this.candidateIdList = []
      // this.addCandidateDialogList.forEach((item, index) => {
      //   if (item.isPitchOn == true) {
      //     this.selectSum++
      //     this.candidateIdList.push(item.personCode)
      //   }
      // })
    },
    // 菁亿分配客户查询
    async distributionSearch() {
      console.log(this.projectIdList, 'this.projectIdList')
      console.log(this.sassaListParam, 'this.sassaListParam')
      this.sassaListParam.projectCodes = this.projectIdList
      const { data } = await list(this.sassaListParam)
      if (data.resultCode == 200) {
        this.distributionTableData = data.data.list
        this.totalDisUser = data.data.total
      }
    },
    // 点击的是全量发布all还是指定发布specify
    async distributionUsersClick(type) {
      if (this.projectIdList && this.projectIdList.length > 1) {
        this.allDisabled = true
      }
      if (type == 'specify') {
        this.distributionUsersDialog = true
        this.distributionSearch()
      } else {
        this.queryInfoPro.pageSize = this.total
        const { data } = await publishAll(this.projectIdList)
        if (data.resultCode == 200) {
          this.$message.success('全量发布成功')
          // 发布成功后清空选中状态
          this.$nextTick(() => {
            this.disCheckedList.forEach((row) => {
              this.$refs.multipleTable.toggleRowSelection(row, false)
            })
          })
          this.distributionUsersDialog = false
          this.search()
        } else {
          this.$message.error('全量发布失败')
        }

        // this.queryInfoPro.pageSize = 10
        // await this.search()
        //   const { data } = await publishUser({
        //   projectId: this.projectIdList,
        //   userCode: this.disIdList.distributionProjectId
        // })
      }
    },
    // 点击批量发布
    isCheckProject() {
      if (this.projectIdList && this.projectIdList.length < 1) {
        this.$message.warning('请先选中项目再进行操作')
        this.allDisabled = true
      }
      // else {
      //   console.log(this.projectIdList, 'this.projectIdList')
      //   this.allDisabled = false
      // }
    },
    // 弹窗关闭
    distributionHandleClose() {
      this.distributionUsersDialog = false
    },
    // 分配菁亿用户
    async distributionUsersFn() {
      const { data } = await publishUser({
        projectId: this.projectIdList,
        userCode: [...this.disIdList.distributionUserCode, ...this.disIdList.distributionProjectId]
      })
      if (data.resultCode == 200) {
        this.$message.success('发布成功')
        // 发布成功后清空选中状态
        this.$nextTick(() => {
          this.disCheckedList.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row, false)
          })
        })
        this.distributionUsersDialog = false
        this.search()
      }
    },
    // 编辑项目
    editProject(row) {
      this.$router.push({
        path: '/businessManagement/editProject',
        query: {
          id: row.id
        }
      })
    },
    // 查询单个
    async findOne(row) {
      const { data } = await selectBYId({
        id: row.id
      })
      if (data.resultCode == 200) {
        this.projectNewsTime.projectApprovalTime = data.data.projectCenterResult.projectApprovalTime
        this.projectNewsTime.talentMappingTime = data.data.projectCenterResult.talentMappingTime
        this.projectNewsTime.talentRecommendTime = data.data.projectCenterResult.talentRecommendTime
        this.projectNewsTime.interviewInvitationTime =
          data.data.projectCenterResult.interviewInvitationTime
        this.projectNewsTime.offerNegotiationTime =
          data.data.projectCenterResult.offerNegotiationTime
        this.projectNewsTime.offerAcceptTime = data.data.projectCenterResult.offerAcceptTime
        this.projectNewsTime.entryTime = data.data.projectCenterResult.entryTime
        this.projectNewsTime.endGuaranteePeriodTime =
          data.data.projectCenterResult.endGuaranteePeriodTime
      }
    },
    // 更新进度 弹窗显示
    async setNews(row) {
      this.setNewsDialogShow = true
      this.projectScheduleIntActive = row.projectScheduleInt ? row.projectScheduleInt : 0
      this.setNewsForm.projectSchedule = row.projectSchedule
      this.setNewsForm.projectId = row.id
      await this.findOne(row)
    },
    // 更新进度
    async setNewsUpdate() {
      this.innerVisible = true
      this.projectScheduleIntActiveForm.newProjectScheduleIntActive = this.projectScheduleIntActive
      // this.projectScheduleIntActive++
      // if (this.projectScheduleIntActive >= 7) {
      //   this.projectScheduleIntActive = 7
      // }
      // this.setNewsForm.projectSchedule = this.projectScheduleIntActive
      // const { data } = await updateProjectSchedule(this.setNewsForm)
      // if (data.resultCode == 200) {
      //   this.$message.success('更新成功')
      //   this.setNewsDialogShow = false
      //   this.search()
      // }
    },
    // 更新进度 弹窗确认
    saveProjectScheduleIntActive(val) {
      this.setNewsForm.projectSchedule =
        this.projectScheduleIntActiveForm.newProjectScheduleIntActive
      this.$refs[val].validate(async (valid) => {
        if (valid) {
          const { data } = await updateProjectSchedule(this.setNewsForm)
          if (data.resultCode == 200) {
            this.$message.success('更新成功')
            this.innerVisible = false
            this.setNewsDialogShow = false
            this.search()
          }
        } else {
          this.$message.error('请完善信息')
          return false
        }
      })
    },
    // 更新进度 弹窗取消
    closeProjectScheduleIntActive() {
      this.innerVisible = false
    },
    // 更新进度 弹窗关闭
    closeNewsDialog() {
      this.setNewsDialogShow = false
      this.search()
    },
    // 查询
    async search() {
      const { data } = await selectProjectCenterTwov1(this.queryInfoPro)
      if (data.resultCode) {
        this.jingyiProjectData = data.data.list
        this.total = data.data.total
      }
    },
    // 去推荐列表页面
    toRecommend(row) {
      const levelItem = {
        companyLogo: row.companyLogo,
        levelItem: row.corporateName,
        id: row.id,
        corporateName: row.corporateName,
        coreRequirements: row.coreRequirements,
        projectScheduleInt: row.projectScheduleInt,
        uniqueId: row.uniqueId
      }
      this.$router.push({
        path: '/businessManagement/recommendedList',
        query: {
          id: row.id,
          levelItem: JSON.stringify(levelItem),
          item: JSON.stringify(row)
        }
      })
    },
    // 按推荐日期排序
    uploadStatusRecommed() {
      this.queryInfoPro.pageNum = 1
      switch (this.statusI) {
        case 0:
          this.queryInfoPro.columnName = '6'
          this.queryInfoPro.order = '0'
          this.statusI++
          break
        case 1:
          this.queryInfoPro.columnName = '6'
          this.queryInfoPro.order = '1'
          this.statusI++
          break
        case 2:
          this.queryInfoPro.columnName = '1'
          this.queryInfoPro.order = ''
          this.statusI = 0
          break
      }
      this.search()
    },
    // 按启动日期排序
    uploadStatusStart() {
      this.queryInfoPro.pageNum = 1
      switch (this.statusI) {
        case 0:
          this.queryInfoPro.columnName = '8'
          this.queryInfoPro.order = '0'
          this.statusI++
          break
        case 1:
          this.queryInfoPro.columnName = '8'
          this.queryInfoPro.order = '1'
          this.statusI++
          break
        case 2:
          this.queryInfoPro.columnName = '1'
          this.queryInfoPro.order = ''
          this.statusI = 0
          break
      }
      this.search()
    },
    // 按更新日期排序
    uploadStatusUpdate() {
      this.queryInfoPro.pageNum = 1
      switch (this.statusI) {
        case 0:
          this.queryInfoPro.columnName = '7'
          this.queryInfoPro.order = '0'
          this.statusI++
          break
        case 1:
          this.queryInfoPro.columnName = '7'
          this.queryInfoPro.order = '1'
          this.statusI++
          break
        case 2:
          this.queryInfoPro.columnName = '1'
          this.queryInfoPro.order = ''
          this.statusI = 0
          break
      }
      this.search()
    },
    uploadStatusPerson() {
      this.queryInfoPro.pageNum = 1
      switch (this.statusI) {
        case 0:
          this.queryInfoPro.columnName = '15'
          this.queryInfoPro.order = '0'
          this.statusI++
          break
        case 1:
          this.queryInfoPro.columnName = '15'
          this.queryInfoPro.order = '1'
          this.statusI++
          break
        case 2:
          this.queryInfoPro.columnName = '1'
          this.queryInfoPro.order = ''
          this.statusI = 0
          break
      }
      this.search()
    },
    // 删除项目 ⭐
    async delProject(item) {
      // if (item.projectSchedule == '冻结') {
      //   return this.$message('此项目已冻结,请解冻后重试')
      // }
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await deleteProject([item.id])
          if (res.resultCode === 200) {
            this.search()
            this.$message.success(res.message)
          }
        })
        .catch(() => {})
    },
    // =================

    changeSelectProjectStatus(data) {
      this.queryInfo.projectStatus = data
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = 30
      this.search()
    },
    async updateCandidateRemarks() {
      const query = {
        candidateRemarks: this.candidateinfo.candidateRemarks,
        id: this.candidateinfo.id
      }
      const { data: res } = await updateCandidateRemarks(query)
      if (res.resultCode === 200) {
        this.dialogVisibleadd = false
        this.$message.success('修改成功!')
        // this.selectPersonChosen()
      }
    },
    //添加人选备注
    addcandidate(item) {
      this.candidateinfo = { ...item }
      this.dialogVisibleadd = true
    },
    addhandleClose() {
      this.dialogVisibleadd = false
    },
    leftproject() {
      this.typeindex = 0
      this.search()
    },
    // 点击人选
    rightcandidates() {
      this.typeindex = 1
      // this.selectPersonChosen()
      this.getCode(this.candidatesCode)
    },
    rightcollection() {
      this.typeindex = 2
    },
    changeTableSorts(column) {
      if (column.order == 'ascending') {
        this.query.order = '1'
        this.query.columnName = column.prop
      } else if (column.order == 'descending') {
        this.query.order = '0'
        this.query.columnName = column.prop
      } else {
        this.query.order = '0'
        this.query.columnName = '1'
      }

      // this.selectPersonChosen()
    },
    // 表格排序
    changeTableSort(column) {
      if (column.order == 'ascending') {
        this.queryInfo.order = '1'
        this.queryInfo.columnName = column.prop
      } else if (column.order == 'descending') {
        this.queryInfo.order = '0'
        this.queryInfo.columnName = column.prop
      } else {
        this.queryInfo.order = '0'
        this.queryInfo.columnName = '7'
      }
      if (this.queryInfo.columnName == 9) {
        this.queryInfo.type = '009'
      }

      this.search()
    },
    // 获取按钮class
    getBtnColorBySchedule(item, val) {
      if (item.projectSchedule === '冻结') {
        // 冻结状态统一样式
        return 'freeze'
      } else if (val === 'isShelf') {
        // 上下架按钮
        if (item.isShelf) {
          return 'workbench'
        } else {
          return 'normal'
        }
      }
    },
    //项目分页器查询 ⭐
    handleSizeChange(val) {
      this.queryInfoPro.pageSize = val
      this.search()
    },
    //项目分页器查询 ⭐
    handleCurrentChange(val) {
      this.queryInfoPro.pageNum = val
      this.search()
    },
    // 人选分页器查询
    handleSizeChanges(val) {
      this.personListQueryInfo.pageSize = val
      this.personListSearch()
    },
    // 人选分页器查询
    handleCurrentChanges(val) {
      this.personListQueryInfo.pageNum = val
      this.personListSearch()
    },
    //清除项目经理选择
    clearItem() {
      sessionStorage.setItem('projectManager', 'xxx')
      this.search()
    },
    clickPitch(item) {
      // console.log(item)
      this.pitchId = item.id
      this.queryInfo.projectType = item.id
      this.search()
    },

    // 查询目标企业
    async searchTargetEnterprise() {
      const { data: res } = await getTargetEnterprise({ id: this.id })
      if (res.resultCode === 200) {
        this.targetEnterpriseList = res.data
        this.dialogVisible = true
      }
    },
    // 获取项目经理
    async getProjectManagerList() {
      const { data: res } = await getProjectManager()
      if (res.resultCode == 200) {
        this.projectManagerList = res.data
        this.dialogProjectManagerList = [...res.data]
        this.projectManagerList.unshift('全部')
        let nameEnglish = sessionStorage.getItem('nameEnglish')
        this.projectManagerValue = nameEnglish
        this.queryInfo.projectManager = nameEnglish
        this.query.projectManager = nameEnglish
        // 条件成立则是项目经理
        if (this.positionType.indexOf('2') != -1) {
          this.queryInfo.projectManager = nameEnglish
          this.queryInfo.customerManager = ''
          this.projectManagerValue = nameEnglish
        }
        // 条件成立则是客户经理
        else if (this.positionType.indexOf('1') != -1) {
          this.queryInfo.projectManager = ''
          this.queryInfo.customerManager = nameEnglish
          this.projectManagerValue = '全部'
        }
        this.search()
      }
    },
    // 新增项目经理选中后的值
    /* async changeAddProject(itemVal, id) {
      let query = {
        manager: itemVal,
        projectId: id
      }
      const { data: res } = await updateProjectManager(query)
      if (res.resultCode == 200) {
        this.$message.success('操作成功')
      }
    }, */
    // 项目经理选择好后的值--查询
    changeProjectManager() {
      sessionStorage.setItem('projectManager', this.projectManagerValue)
      this.queryInfo.projectManager = this.projectManagerValue
      this.query.projectManager = this.projectManagerValue
      if (this.projectManagerValue == '全部') {
        this.queryInfo.projectManager = ''
        this.query.projectManager = ''
      }
      // this.selectPersonChosen()
      this.search()
    },
    toworkbench(item) {
      this.$router.push({
        path: '/businessManagement/workbench',
        query: {
          item: JSON.stringify(item),
          height: 2
        }
      })
    },
    // 跳转到工作台页面
    clickGoWorkbench(item) {
      // if (item.projectSchedule == '冻结') {
      //   return this.$message('此项目已冻结,请解冻后重试')
      // }
      this.$router.push({
        path: '/businessManagement/workbench',
        query: {
          item: JSON.stringify(item)
        }
      })
    },
    // 删除项目
    async deleteProject(item) {
      // if (item.projectSchedule == '冻结') {
      //   return this.$message('此项目已冻结,请解冻后重试')
      // }
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await projectCenterDeleteById({ id: item.id })
          if (res.resultCode === 200) {
            this.search()
            this.$message.success(res.message)
          }
        })
        .catch(() => {})
    },
    // 上下架项目
    async setProjectShelf(item) {
      // if (item.projectSchedule == '冻结') {
      //   return this.$message('此项目已冻结,请解冻后重试')
      // }
      const { id, isShelf } = item
      const txt = isShelf ? '下架' : '上架'
      const query = { id, isShelf: !isShelf }
      const { data: res } = await projectShelf(query)
      if (res.resultCode === 200) {
        this.$message.success(txt + '成功!')
        this.search()
      } else {
        this.$message.error(txt + '失败!')
      }
    },
    // 查询企业
    async searchEnterprise() {
      const { data: res } = await getEnterprise({ companyFullName: this.enterprise })
      if (res.resultCode === 200) {
        if (res.data) {
          this.enterpriseObj = res.data
          this.isShowEnterprise = true
        } else {
          this.enterpriseObj = {}
          this.isShowEnterprise = false
        }
      }
    },
    // searchLabel(data) {
    //   this.queryInfo.cilentIndustry = data
    //   this.search()
    // },
    //查询一览
    // async search() {
    //   this.loading = true
    //   // console.log(this.queryInfo, JSON.stringify(this.queryInfo), "this.queryInfothis.queryInfothis.queryInfo");
    //   const { data: res } = await selectProjectCenterTwo(this.queryInfo)
    //   if (res.resultCode === 200) {
    //     this.projectTable = res.data.list
    //     this.total = res.data.total
    //     this.loading = false
    //   } else {
    //     this.loading = false
    //     this.$message.error('获取项目信息失败!')
    //   }
    //   // const newProjectTable = this.projectTable.map(item => {
    //   //   // console.log("遍历数据",item.projectStatus);
    //   //   return item.projectStatus
    //   // })
    //   // console.log("遍历数据", newProjectTable);
    // },
    //根据code查询标签
    async getCode(code) {
      const res = await codeType({ code: code })
      if (res.data.resultCode == 200) {
        const newCodeData = res.data.data.map((item) => {
          return item.codeName
        })
        if (code == '021') {
          const { data: req } = await number(newCodeData)
          const newNumber = req.data.split(',')
          const handleCodeData = newCodeData.map((item, index) => {
            return item + `(${newNumber[index]})`
          })
          this.codeData = handleCodeData
        }
        if (code == '022') {
          const { data: req } = await selectPersonChosenNumber(newCodeData)
          const newNumber = req.data.split(',')
          const handleCodeData = newCodeData.map((item, index) => {
            return item + `(${newNumber[index]})`
          })
          this.candidatesData = handleCodeData
        }
      }
    },
    // 项目选择发生变化的时候 ⭐
    limitClick() {
      this.queryInfoPro.pageNum = 1
      if (this.queryInfoPro.projectStatus.length > 0) {
        ;(this.queryInfoPro.projectStatus = []), (this.noLimit = ['不限'])
        this.search()
      } else {
        this.noLimit = ['不限']
        this.search()
      }
    },
    // 人选选择发生变化的时候
    changeCandidateStatus(val) {
      this.query.candidateStatus = val
      // this.selectPersonChosen()
    },
    // 多选发生变化时 ⭐
    noLimitClick() {
      this.queryInfoPro.pageNum = 1
      if (this.queryInfoPro.projectStatus.length > 0) {
        this.noLimit = []
        this.search()
      } else {
        this.noLimit = ['不限']
        this.search()
      }
    },

    // async selectPersonChosen() {
    //   this.loading = true
    //   const { data: res } = await selectPersonChosen({ ...this.query })
    //   if (res.resultCode === 200) {
    //     this.personTable = res.data.list
    //     this.persontotal = res.data.total
    //     this.loading = false
    //   } else {
    //     this.loading = false
    //     this.$message.error('获取人选信息失败!')
    //   }
    // },

    //通过省市筛选
    searchArae(val) {
      this.queryInfo.workIntro = val.country
      this.queryInfo.companyProvince = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.companyCity = val.city
      }
      this.search()
    },
    // 排序
    handleSort(val, name) {
      // up为正序
      this.sortField = name
      switch (name) {
        case '项目进度':
          this.queryInfo.type = '011'
          this.queryInfo.columnName = 'project_schedule'
          this.priority = { ...defaultPriority }
          this.updateTime = { ...defaultUpdateTime }
          this.projectSchedule.isDownActive = !this.projectSchedule.isDownActive
          this.projectSchedule.isUpActive = !this.projectSchedule.isDownActive
          break
        case '优先级':
          this.queryInfo.type = '009'
          this.queryInfo.columnName = 'pc.code_id'
          this.projectSchedule = { ...defaultProjectSchedule }
          this.updateTime = { ...defaultUpdateTime }
          this.priority.isDownActive = !this.priority.isDownActive
          this.priority.isUpActive = !this.priority.isDownActive
          break
        case '更新时间':
          this.queryInfo.columnName = 'update_time'
          this.projectSchedule = { ...defaultProjectSchedule }
          this.priority = { ...defaultPriority }
          this.updateTime.isDownActive = !this.updateTime.isDownActive
          this.updateTime.isUpActive = !this.updateTime.isDownActive
          break
        /* case '公司名称':
          this.queryInfo.columnName = 'corporate_name'
          break
        case '职位名称':
          this.queryInfo.columnName = 'recruitment_position'
          break */
      }
      if (val === 'up') {
        this.queryInfo.order = 0
      } else {
        this.queryInfo.order = 1
      }
      this.search()
    },
    // async changeProjectStatus(val, info) {
    //   const query = {
    //     id: info.id,
    //     projectStatus: val
    //   }
    //   const { data: result } = await updateStatus(query)
    //   if (result.resultCode === 200) {
    //     this.$message.success('修改成功')
    //     this.search()
    //     this.getCode(this.typeCode)
    //   } else {
    //     return this.$message.error('修改失败！')
    //   }
    // },
    // 改变项目优先级 ⭐
    async changePriority(val, info) {
      if (info.priority == '冻结') {
        //当前为'冻结'时
        // const { data: res } = await updateFreezeState({
        //   projectId: info.id
        // })
        // if (res.resultCode == 200) {
        info.priority = val
        const { data: result } = await updatePriority(info)
        if (result.resultCode === 200) {
          this.$message.success('修改成功')
          this.search()
        } else {
          return this.$message.error('修改失败！')
        }
        // }
        // else {
        //   return this.$message.error('修改失败！')
        // }
      } else if (info.priority != '冻结' && val == '冻结') {
        //当前不为'冻结'且选中'冻结'
        // const { data: res } = await updateFreezeState({
        //   projectId: info.id
        // })
        // if (res.resultCode == 200) {
        info.priority = val
        const { data: result } = await updatePriority(info)
        if (result.resultCode === 200) {
          this.$message.success('修改成功')
          this.search()
        } else {
          return this.$message.error('修改失败！')
        }
        // } else {
        //   return this.$message.error('修改失败！')
        // }
      } else {
        //当前不为'冻结'且选中的不是'冻结'
        info.priority = val
        const { data: result } = await updatePriority(info)
        if (result.resultCode === 200) {
          this.$message.success('修改成功')
          this.search()
        } else {
          return this.$message.error('修改失败！')
        }
      }
    },

    // 改变项目状态 ⭐
    async changeProjectStatus(val, info) {
      console.log(info, 'info')
      if (info.projectStatus == '冻结') {
        //当前为'冻结'时
        // const { data: res } = await updateFreezeState({
        //   projectId: info.id
        // })
        // if (res.resultCode == 200) {
        info.projectStatus = val
        const { data: result } = await updateStatus(info)
        if (result.resultCode === 200) {
          this.$message.success('修改成功')
          this.search()
        } else {
          return this.$message.error('修改失败！')
        }
        // }
        // else {
        //   return this.$message.error('修改失败！')
        // }
      } else if (info.projectStatus != '冻结' && val == '冻结') {
        //当前不为'冻结'且选中'冻结'
        // const { data: res } = await updateFreezeState({
        //   projectId: info.id
        // })
        // if (res.resultCode == 200) {
        info.projectStatus = val
        const { data: result } = await updatePriority(info)
        if (result.resultCode === 200) {
          this.$message.success('修改成功')
          this.search()
        } else {
          return this.$message.error('修改失败！')
        }
        // } else {
        //   return this.$message.error('修改失败！')
        // }
      } else {
        //当前不为'冻结'且选中的不是'冻结'
        info.projectStatus = val
        const { data: result } = await updatePriority(info)
        if (result.resultCode === 200) {
          this.$message.success('修改成功')
          this.search()
        } else {
          return this.$message.error('修改失败！')
        }
      }
    },

    //选择企业名称  调接口获取职位列表
    async enterpriseNameSelect(item) {
      const { companyCode, companyName, value } = item
      this.addProjectForm.companyName = companyName
      this.addProjectForm.companyCode = companyCode
      const { data: res } = await getCompanyNameList({ name: value })
      if (res.resultCode === 200) {
        const obj = res.data[0] // 获取接口数据
        // 获取需要同步的数据
        const obj1 = {
          companyCode: obj.companyCode, // 企业编号
          enterpriseName: obj.companyName, // 公司名称
          companyLogo: obj.companyLogo, // 公司logo
          companyProfile: obj.companyBriefIntroduction, // 公司简介
          industry: obj.industry // 行业
        }
        this.addProjectForm = Object.assign(this.addProjectForm, obj1) // 浅拷贝
        this.enterpriseNameList = []
        this.currentErpriseName = value // 赋值当前选中的企业名称
        // 调接口获取职位数据
        this.positionList = []
        const { data: result } = await selectPosition({ name: value })
        if (result.resultCode === 200) {
          result.data.forEach((item) => {
            this.positionList.push({
              value: item.jobTitle
            })
          })
          // this.positionList = result.data
        }
      }
    },
    //模糊查询企业名称
    async enterpriseNameQuerySearch(str, cb) {
      if (str != '') {
        const { data: res } = await getCompanyNameList({ name: str })
        if (res.resultCode === 200) {
          res.data.forEach((item) => {
            this.enterpriseNameList.push({
              value: item.companyFullName,
              companyName: item.companyName,
              companyCode: item.companyCode
            })
          })
          cb(this.enterpriseNameList)
        } else {
          this.$message.error('查询失败！')
        }
      }
    },
    //模糊查询职位名称
    async positionListQuerySearch(str, cb) {
      if (!str) {
        // 输入框有值
        if (!this.currentErpriseName) {
          // 没有填写企业名称
          return cb([
            {
              value: '暂无数据'
            }
          ])
        } else {
          const { data: res } = await selectPosition({
            name: this.currentErpriseName,
            jobTitle: str
          })
          this.positionList = []
          if (res.resultCode === 200) {
            res.data.forEach((item) => {
              this.positionList.push({
                value: item.jobTitle
              })
            })
            let arr = []
            if (this.positionList.length > 0) {
              arr = this.positionList
            } else {
              arr = [
                {
                  value: '暂无数据'
                }
              ]
            }
            cb(arr)
          } else {
            this.$message.error('查询失败！')
          }
        }
      } else {
        let arr = []
        if (this.positionList.length > 0) {
          arr = this.positionList
        } else {
          arr = [
            {
              value: '暂无数据'
            }
          ]
        }
        cb(arr)
      }
    },
    // 企业搜索 输入值变化时
    inputChanged() {
      this.enterpriseNameList = []
      this.positionList = []
    },
    // 岗位名称 选中值发生变化时
    async positionSelect(item) {
      if (item.value !== '暂无数据') {
        const { data: res } = await selectPosition({
          name: this.currentErpriseName,
          jobTitle: item.value
        })
        if (res.resultCode === 200) {
          let obj = res.data[0]
          const obj1 = {
            positionId: obj.id, // 职位id
            positionType: obj.positionType, // 职位类型
            dutyStation: obj.dutyStation, // 工作地址-详细地址
            isAnnual: obj.isAnnual, // 月薪或者年薪0->月薪；1->年薪
            salaryRange: obj.salaryRange, // 薪资范围
            jobDescription: obj.jobDescription, // 职位描述
            area: obj.companyArea, // 工作地区 地区
            province: obj.companyProvince, // 工作省份
            city: obj.companyCity, // 工作城市
            requiredSkills: obj.requiredSkills, // 所需技能
            recruitmentPosition: obj.jobTitle //岗位名称
          }
          this.form = Object.assign(this.addProjectForm, obj1)
        }
      }

      // 职位使用下拉选择时
      // let obj = {}
      // this.positionList.forEach((el) => {
      //   if (el.id == val) {
      //     obj = el
      //   }
      // })
      // const obj1 = {
      //   positionType: obj.positionType, // 职位类型
      //   dutyStation: obj.dutyStation, // 工作地址-详细地址
      //   isAnnual: obj.isAnnual, // 月薪或者年薪0->月薪；1->年薪
      //   salaryRange: obj.salaryRange, // 薪资范围
      //   jobDescription: obj.jobDescription, // 职位描述
      //   area: obj.companyArea, // 工作地区 地区
      //   province: obj.companyProvince, // 工作省份
      //   city: obj.companyCity, // 工作城市
      //   requiredSkills: obj.requiredSkills, // 所需技能
      //   recruitmentPosition: obj.jobTitle //岗位名称
      // }
      // this.form = Object.assign(this.form, obj1)
    },

    closeAddDialog() {
      this.addProjectDialogShow = false
      this.form = { ...defaultForm }
      this.currentErpriseName = ''
      this.positionList = []
    },
    //成功过后手动将文件添加到展示列表里  3月20日删除上传
    /* uploadFile(file) {
      if (file.file) {
        this.fileList.push(file.file)
      }
    }, */
    //删除上传的文件
    /* handleCloseUpload(i) {
      this.fileList.splice(i, 1)
      this.form.file = []
    }, */
    // 跳转到详情页面
    clickToDetails(item) {
      // /projectCenter/selectProjectBYId
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/projectCenter/selectProjectBYId')
      if (hasPermission) {
        this.$router.push({
          path: '/businessManagement/projectCenter/addProject',
          query: {
            id: item.id
          }
        })
      } else {
        this.$message.warning('暂无权限')
      }
    },
    /* handleControl(val, info) {
      if (val === '删除') {
        this.id = info.id
        this.deleteItem(info.id)
      } else if (val === '目标企业') {
        this.id = info.id
        this.searchTargetEnterprise()
      } else if (val === '添加') {
        this.submitTargetEnterprise()
      } else if (val === '取消') {
        this.cancelTargetEnterprise(info.enterpriseId)
      } else {
        let name = ''
        switch (val) {
          case '话术管理':
            name = 'OperationManagement'
            break

          case '候选人':
            name = 'Candidate'
            break

          case '项目记录':
            name = 'projectRecord'
            break

          default:
            break
        }
        this.$router.push({
          name,
          query: {
            ...info,
            searchInfo: JSON.stringify(this.queryInfo)
          }
        })
      }
    }, */
    /* deleteItem(val) {
      this.$confirm('此操作不可撤回，请谨慎删除', '提示')
        .then(async () => {
          const { data: res } = await deleteProjectCenter([val])
          if (res.resultCode === 200) {
            this.$message.success('删除成功')

            this.search()
          }
        })
        .catch(() => {})
    }, */
    /* viewItem(id) {
      this.$router.push({
        name: 'ViewProject',
        query: {
          id,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    }, */
    // 添加目标企业
    /* async submitTargetEnterprise() {
      const { data: res } = await addTargetEnterprise({
        enterpriseId: this.enterpriseObj.companyCode,
        projectId: this.id
      })
      if (res.resultCode === 200) {
        this.$message.success('添加目标企业成功')
        this.enterprise = ''
        this.isShowEnterprise = false
        this.enterpriseObj = {}

        this.searchTargetEnterprise()
      }
    }, */
    // 弹窗关闭
    /* handleClose() {
      this.dialogVisible = false
      this.enterprise = ''
      this.enterpriseObj = {}
      this.isShowEnterprise = false
    }, */
    // 取消已添加的企业
    /* cancelTargetEnterprise(id) {
      this.$confirm('此操作不可撤回，请谨慎操作', '提示')
        .then(async () => {
          const { data: res } = await deleteTargetEnterprise({ id })
          if (res.resultCode === 200) {
            this.$message.success('取消成功')
            this.searchTargetEnterprise()
          }
        })
        .catch(() => {})
    }, */
    // 监听优先级改变 val为选中的值，info.priority为选中前的值

    // 修改客户经理
    async modifyCustomerManager(val) {
      if (this.roleId == 1) {
        this.customerManagerDialogForm = true
        this.customerManagerForm.manager = val.customerManagers
        const res = await updategetCustomerManager(this.customerManagerForm)
        this.customerManagerList = res.data.data
        this.customerManagerForm.projectId = val.id
      } else {
        this.$message.error('没有修改权限！')
      }
      // console.log(val.customerManagers);
    },
    // 发送修改请求
    async modifyApiCustomerManager() {
      const { data: res } = await selectUpdateCustomerManager(this.customerManagerForm)
      if (res.resultCode == 200) {
        this.customerManagerDialogForm = false
        this.$message.success('修改成功！')
        this.search()
      } else {
        this.$message.error('修改失败！')
      }
    },

    // 清空项目搜索框 ⭐
    cleanSearch(val) {
      if (val == '') this.search()
      this.personListSearch()
    },

    // 清空人选搜索框 cleanQuerySearch
    cleanQuerySearch(val) {
      // if (val == '') this.selectPersonChosen()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../assets/style/businessManagement/JingyiProject.less';
.mr-r-10 {
  margin-right: 10px;
}

.project_center {
  width: 100%;
  height: 100%;

  .candidates_flex {
    display: flex;
    width: 120px;
    justify-content: space-between;
    padding-left: 20px;
    position: relative;
    top: -10px;

    .left_active {
      border-bottom: 2px solid #079992;
      cursor: pointer;
    }

    .left {
      color: #8c8787;
      cursor: pointer;
    }
  }
}

/deep/ .el-card__body {
  padding: 16px;
}

/deep/ .el-form-item {
  margin-bottom: 5px;
}

.war-message {
  z-index: 3000 !important;
}

.mini-select {
  max-width: 80px !important;
}

.container {
  height: calc(100% - 56px);
  overflow: scroll;
}
.tabs {
  padding: 4px 20px;
  border-radius: 4px;
  background: #fff;
}

.pagination {
  width: 100%;
  text-align: center;
  // margin-top: 10px;
  // margin: 10px 0 20px 0;
}

.labelStyle {
  .project_type {
    display: flex;
    max-height: 40px;

    .type_item {
      padding: 0px 10px;
      cursor: pointer;
      color: #333333;
      height: 32px;
      line-height: 32px;
      margin-right: 10px;
    }
  }

  .pitch {
    border: 1px solid #17757a;
    border-radius: 4px;
    color: #17757a !important;
  }
}

.page_nation {
  width: 100%;

  .green_back {
    background: #48dc5f;
    width: 46px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    border-radius: 9px;
    display: inline-block;
  }

  .yellowbg {
    background: #ffa24d;
  }

  .redbg {
    background: #ff4d4d;
  }

  .bluebg {
    background: #24b6f4;
  }

  .huibg {
    background: #999999;
  }
  .success {
    background: #18238a;
  }

  .row {
    display: flex;
    justify-content: center;

    .row_css {
      color: #17757a;
      margin-right: 10px;
      cursor: pointer;
    }

    .row_red {
      color: #fa5050;
      cursor: pointer;
    }
  }

  .contentStyle {
    width: 100%;
    display: flex;
    // align-items: center;
    justify-content: left;
    margin-bottom: 12px;
    background: #fff;
  }

  .contentStyle:hover {
    .enterprise .enterprise_title {
      color: #17757a !important;
    }
  }
}

.content_left {
  display: flex;
  width: 50%;
  min-width: 50%;

  .color1 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #0ea4e7 !important;
  }

  .color2 {
    text-align: center;
    word-wrap: break-word;
    box-sizing: border-box;
    padding-top: 10px;
    background-color: #ffbe76 !important;
  }

  .color3 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #7ed6df !important;
  }

  .color4 {
    text-align: center;
    word-wrap: break-word;
    box-sizing: border-box;
    padding-top: 21px;
    background-color: #4fc3f7 !important;
  }

  .color5 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #c14ef3 !important;
  }

  .color6 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #26bf56 !important;
  }

  .color7 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #809fb8 !important;
  }

  .color8 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #ababab !important;
  }

  .color9 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #079992 !important;
  }

  .color10 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #f6e58d !important;
  }

  .color11 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #ff7979 !important;
  }

  .color12 {
    text-align: center;
    word-wrap: break-word;
    box-sizing: border-box;
    padding-top: 21px;
    background-color: #badc58 !important;
  }

  .color13 {
    text-align: center;
    word-wrap: break-word;
    box-sizing: border-box;
    padding-top: 21px;
    background-color: #6ab04c !important;
  }

  .schedule {
    width: 30px;
    // height: 100%;
    height: 126px;
    background-color: skyblue;
    color: #fff;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    // text-align: center;
    // word-wrap: break-word;
  }

  .primary {
    padding: 22px 0 22px 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    // border: 1px solid red;
    // padding: 22px 0 0 15px;
    .time {
      display: flex;
      flex-flow: row wrap;
      font-size: 14px;
      color: #999999;
      // margin-top: 10px;
    }

    width: 80%;

    .enterprise {
      display: flex;
      justify-content: left;
      width: 100%;
      margin-right: 20px;

      .enterprise_title {
        width: 280px;
        max-width: 280px;
        font-size: 18px;
        font-weight: 700;
        color: #333333;
        cursor: pointer;
        margin-right: 10px;
      }

      .tag {
        width: 34px;
        padding: 0px 10px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid #17757a;
        color: #17757a;
        font-size: 14px;
        margin-left: 10px;
        box-sizing: border-box;
        // margin: 0 34px 0 14px;
      }

      .imageBox {
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
          border-radius: 2px;
          margin-right: 9px;
        }

        .box {
          // 对齐用
          width: 24px;
          height: 24px;
          border-radius: 2px;
          margin-right: 9px;
        }

        .img_txt {
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 160px;
          font-size: 14px;
          color: #333333;
        }
      }
    }

    .recommend_interview_Number {
      display: flex;

      // margin-top: 40px;
      .recommend {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        background-color: #f7f7f7;
        border-radius: 4px;
        color: #333333;
        font-size: 14px;
        padding: 2px 10px;
        margin-right: 18px;

        @media (max-width: 1366px) {
          .text {
            font-size: 12px !important;
          }
        }

        .line {
          width: 1px;
          height: 10px;
          background-color: #c4c4c4;
          margin: 0 7px;
        }
      }
    }
  }
}

.content_right {
  display: flex;
  justify-content: space-around;
  padding: 22px 0;

  .manager {
    margin-right: 40px;

    .project_manager {
      display: flex;
      align-items: center;
      // margin-top: 8px;
      margin-bottom: 10px;

      .label {
        width: 75px;
        color: #333333;
        font-size: 14px;
      }

      .value {
        display: flex;
        flex-flow: row wrap;
        justify-content: left;
        width: 100px;

        span {
          color: #333333;
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }

    .customer_manager {
      display: flex;
      flex-flow: row nowrap;
      justify-content: left;

      .label {
        width: 75px;
        color: #333333;
        font-size: 14px;
      }

      span {
        color: #333333;
        font-size: 14px;
      }
    }
  }

  .operation {
    // width: 235px;
    // margin-right: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    padding-right: 30px;
    box-sizing: border-box;
    text-align: right;

    .new_time {
      font-size: 12px;
      color: #999999;
    }

    .operating_button {
      margin-top: 25px;
      display: flex;

      .btn_box {
        width: 80px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        border-radius: 4px;
        cursor: pointer;
      }

      .workbench {
        border: 1px solid #17757a;
        color: #17757a;
      }

      .normal {
        border: 1px solid #999;
        color: #999;
      }

      .red {
        border: 1px solid #ff371c;
        color: #ff371c;
      }

      .freeze {
        border: 1px solid #999999;
        color: #999999;
      }
    }
  }
}

.level {
  height: 32px;
  display: flex;
  align-items: center;
  margin-right: 40px;

  /deep/.el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  /deep/.el-input__icon {
    line-height: 32px;
  }
}

.enterporise_list_input_add {
  display: flex;
  flex-direction: row;
  align-items: center;
  // background: #ececec;
  .left {
    display: flex;
    min-width: 36%;
  }
}

.enterporise_list_input_add .right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin-left: auto;
  margin-right: 20px;

  .add_enterprise {
    margin-left: 10px;
    background-color: #17757a;
    border-color: #17757a;
  }
}

.project_manager_search {
  display: flex;
  align-items: center;
  margin-left: 50px;

  .project_manager {
    margin-right: 10px;
    text-align: center;
    min-width: 64px;
  }

  /deep/.el-select {
    min-width: 100px;
  }
}

.input_new {
  // margin-left: 40px;
  margin-right: 20px;
  min-width: 140px;
  display: flex;
  align-items: center;
  /deep/ .el-button {
    border-radius: 0 4px 4px 0;
    height: 40px;
  }

  /deep/ .el-button--default {
    background-color: #17757a;

    i {
      color: #fff;
    }
  }
}

.elPagination {
  padding: 20px;
  text-align: right;
}

.search-input {
  width: 60%;

  /deep/ .el-input-group__append {
    background: #17757a;
    color: #fff;
    border: 1px solid #17757a;
  }
}

.search-enterprise {
  padding-bottom: 10px;
  border-bottom: 1px solid #333333;
}

.enterpriseInfo {
  display: flex;
  align-items: center;
  padding: 15px 0;
  justify-content: space-between;

  .left {
    display: flex;
  }

  .info {
    padding: 4px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .companyFullName {
      font-size: 16px;
      color: #333333;
    }

    .industry {
      display: flex;
      font-size: 12px;
      color: #8a8a8a;

      .area {
        position: relative;
        margin-left: 20px;

        .line {
          color: #c4c4c4;
          position: absolute;
          top: -1px;
          left: -10px;
        }
      }
    }
  }
}

/* .hasAddEnterprise {
  p {
    color: #333333;
    font-weight: 700;
    padding: 10px 0;
    font-size: 14px;
    border-bottom: 1px solid #e5e5e5;
  }
  .targetEnterprise {
    border-bottom: 1px solid #e5e5e5;
    .right {
      display: flex;
    }
  }
} */
.add_project_dialog_left {
  ::v-deep .el-dialog__body {
    padding: 30px 70px !important;
  }
  .newBtn {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
  }
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .line {
      width: 4px;
      height: 20px;
      border-radius: 4px;
      background-color: #17757a;
      margin-right: 8px;
    }

    .title_txt {
      color: #333333;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }
  }

  .dialog-footer {
    .button_box {
      display: flex;
      justify-content: center;
      font-size: 12px;

      .add {
        width: 64px;
        height: 33px;
        border-radius: 4px;
        background-color: #17757a;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 34px;
      }

      .cancel {
        width: 64px;
        height: 33px;
        border-radius: 4px;
        border: 1px solid #17757a;
        display: flex;
        align-items: center;
        color: #17757a;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
}
.add_project_dialog {
  .newBtn {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
  }
  .title {
    display: flex;
    // align-items: center;
    justify-content: center;

    .line {
      width: 4px;
      height: 20px;
      border-radius: 4px;
      background-color: #17757a;
      margin-right: 8px;
    }

    .title_txt {
      color: #333333;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }
  }

  .dialog-footer {
    .button_box {
      display: flex;
      justify-content: center;
      font-size: 12px;

      .add {
        width: 64px;
        height: 33px;
        border-radius: 4px;
        background-color: #17757a;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 34px;
      }

      .cancel {
        width: 64px;
        height: 33px;
        border-radius: 4px;
        border: 1px solid #17757a;
        display: flex;
        align-items: center;
        color: #17757a;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
}

.add_project_manager {
  /deep/.el-icon-close {
    right: -5px !important;
    top: 0 !important;
  }
}

.block_flex {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #17757a;
  position: relative;
  top: -2px;
  left: -4px;
}

.candidateRemarks {
  width: 320px;
}

.candidateRemarks_txt {
  display: inline-block;
  width: 320px;
  color: #212121 !important;
  white-space: nowrap;
  /* 不换行 */
  overflow: hidden;
  /* 超出部分隐藏 */
  text-overflow: ellipsis;
  /* 用省略号表示超出部分 */
}

/deep/ .add_project_dialog .el-form-item__content {
  margin-bottom: 10px;
}

/deep/ .add_project_form .el-select {
  width: 80%;
}

/deep/ .add_project_form .el-autocomplete {
  width: 80%;
}

/deep/ .add_project_form .el-input {
  width: 80%;
}
.buttonContent {
  display: flex;
}

/deep/ .el-checkbox-button__inner {
  border: 1px solid #fff !important;
}

/deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  border: 1px solid #17757a !important;
  background-color: #fff;
  color: #17757a;
}

/deep/ .el-checkbox-button__inner:hover {
  color: #17757a;
}

/deep/.el-checkbox-button__inner {
  padding: 9px 10px;
}

// /deep/ .el-checkbox-button.is-focus .el-checkbox-button__inner{
//     border-color:#17757A !important
// }
/deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  box-shadow: none;
}

.openClose {
  display: flex;
  justify-content: space-between;
  .openButton {
    width: 10%;
    line-height: 30px;
    color: #1e9fff;
    cursor: pointer;
    text-align: center;
  }
}
.openInfo {
  width: 90%;
  max-height: 40px;
  overflow: hidden;
  // transition: all 1s linear;
}
.newClass {
  width: 90%;
  max-height: 400px;
  overflow: auto;
  transition: all 1s linear;
}
/deep/ .el-radio-button__inner {
  border: 1px solid #fff !important;
  padding: 9px 10px;
}
/deep/ .el-radio-button__inner:hover {
  color: #17757a;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff;
  color: #17757a;
  border: 1px solid #17757a !important;
  box-shadow: none;
}
/deep/ .el-radio-button.is-checked .el-radio-button__inner {
  box-shadow: none;
}

// ---
.orderData {
  display: flex;
  align-items: center;
  width: 39%;
  .num {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    span {
      color: rgba(23, 117, 122, 1);
    }
  }
}
.upload_time {
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 32px;
  .san {
    margin-left: 6px;
    margin-right: 24px;
    i {
      display: block;
      font-size: 14px;
      position: absolute;
    }
    i:nth-child(1) {
      top: 0;
    }
    i:nth-child(2) {
      top: 7px;
    }
  }
}
.caretTime:hover {
  cursor: pointer;
}
.isActiveTime1 {
  color: rgba(23, 117, 122, 1) !important;
}
.iconColor {
  color: #c0c4cc !important;
}
::v-deep .el-dialog__footer {
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
.frozen {
  padding-left: 20px;
  color: #fd5469;
  cursor: pointer;
}
// 盒子样式
// .JingyiProject:hover {
//   border: 1px solid rgba(23, 117, 122, 1);
//   border-radius: 4px;
// }
.JingyiProject {
  position: relative;
  font-family: PingFang SC;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 20px 0 0 !important;
  background: #fff;
  margin-bottom: 12px;
  .number {
    top: 0px;
    right: 0;
    position: absolute;
    width: 121px;
    height: 20px;
    border-radius: 0px 4px 0px 4px;
    color: rgba(23, 117, 122, 1);
    background: rgba(230, 250, 250, 1);
    border: 1px solid rgba(217, 242, 242, 1);
    text-align: center;
    font-size: 14px;
  }
  .projectItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .proLeft {
      display: flex;
      width: 38%;
      // justify-content: space-between;
      align-items: center;
      .left_title {
        writing-mode: vertical-lr;
        text-orientation: upright;
        letter-spacing: 0px;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        width: 32px;
        height: 170px;
        margin-right: 12px;
        color: #ffffff;
      }
      .left_title1 {
        background: rgba(246, 229, 141, 1);
      }
      .left_title2 {
        background: rgba(255, 190, 118, 1);
      }
      .left_title3 {
        background: rgba(255, 121, 121, 1);
      }
      .left_title4 {
        background: rgba(126, 214, 223, 1);
      }
      .left_title5 {
        background: rgba(79, 195, 247, 1);
      }
      .left_title6 {
        background: rgba(186, 220, 88, 1);
      }
      .left_title7 {
        background: rgba(106, 176, 76, 1);
      }
      .left_title8 {
        background: rgba(7, 153, 146, 1);
      }
      .left_title9 {
        background: rgba(171, 171, 171, 1);
      }
      .left_l {
        // padding: 20px 0;
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        .l_top {
          padding-bottom: 20px;
          display: flex;
          .t_left {
            margin-right: 60px;
            .projectName {
              font-size: 18px;
              font-weight: 600;
              color: rgba(51, 51, 51, 1);
              padding-bottom: 2px;
              cursor: pointer;
              display: block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .recommendDate {
              color: rgb(153, 153, 153);
            }
            .projectName:hover {
              color: rgba(23, 117, 122, 1);
            }
            span {
              font-size: 14px;
              font-weight: 400;
            }
          }
          .t_right {
            display: flex;
            align-items: center;
            img {
              width: 31px;
              height: 31px;
              border-radius: 4px;
            }
            .dis {
              display: flex;
              flex-direction: column;
              padding: 0 8px;
              span:nth-child(1) {
                font-size: 14px;
                font-weight: 400;
                line-height: 19.6px;
                color: rgba(51, 51, 51, 1);
              }
              span:nth-child(2) {
                font-size: 10px;
                font-weight: 400;
                line-height: 19.6px;
                color: rgba(51, 51, 51, 1);
                span {
                  font-size: 10px;
                }
              }
            }
            .tag {
              padding: 0px 9px 0px 9px;
              border-radius: 2px;
              margin-top: -6px;
            }
            .tag1 {
              border: 1px solid rgba(50, 115, 239, 1);
              color: rgba(50, 115, 239, 1);
            }
            .tag2 {
              color: rgba(23, 117, 122, 1);
              border: 1px solid rgba(23, 117, 122, 1);
            }
          }
        }
        .l_bom {
          display: flex;
          div {
            font-size: 14px;
            font-weight: 400;
            border-radius: 4px;
            color: rgba(51, 51, 51, 1);
            background: rgba(247, 247, 247, 1);
            padding: 5px;
            margin-right: 16px;
            span {
              padding: 0 2px 0 2px;
            }
          }
        }
      }
    }
    .proCenter {
      width: 33%;
      display: flex;
      align-items: flex-start;
      font-size: 14px;
      font-weight: 400;
      height: 130px;
      color: rgba(51, 51, 51, 1);
      .projectUser {
        height: 130px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        font-family: PingFang SC;
        .projectManager {
          display: block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .customerManager {
          display: block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .first {
        margin-left: 30px;
        margin-top: 20px;
        display: flex;
        align-items: center;
      }
      .status {
        margin-left: 30px;
        margin-top: 20px;
        display: flex;
        align-items: center;
      }
    }
    .proRight {
      width: 28%;
      height: 130px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-around;
      //justify-content: space-between;
      .time {
        // padding: 12px 0 20px 0;
        padding: 2px 0 2px 0;
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
        text-align: right;
        .tag {
          color: rgba(23, 117, 122, 1);
        }
        span:nth-child(2) {
          padding-left: 40px;
        }
      }
      .el-button.is-plain:hover {
        color: rgba(23, 117, 122, 1) !important;
      }
    }
  }
}
.progress_box {
  flex: 1;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 20px 0 20px 0;
  // padding-right: 114px;

  .progress {
    width: 100%;
    box-sizing: border-box;
    height: 98px;
    background-color: rgba(200, 211, 212, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;

    /deep/.el-steps--horizontal {
      flex: 1;
    }

    .item {
      color: #17757a;
      font-size: 14px;
    }

    .mapping {
      line-height: 1;
      display: flex;
      align-items: center;
      height: 38px;
      justify-content: center;
    }

    .have_not_started {
      color: #333333;
    }

    .time {
      color: #333333;
    }

    /deep/.el-step__icon-inner {
      display: none;
    }

    /deep/.el-step__icon {
      width: 16px;
      height: 16px;
    }

    /deep/.el-step__line {
      top: 8px;
    }

    // 已完成
    /deep/
      .el-steps.el-steps--horizontal
      .el-step.is-horizontal.is-center
      .el-step__head.is-finish
      .el-step__icon {
      z-index: 1;
      color: #17757a;
      border-color: #17757a;
    }

    // 已完成线
    /deep/
      .el-steps.el-steps--horizontal
      .el-step.is-horizontal.is-center
      .el-step__head.is-finish
      .el-step__line {
      border-color: rgba(23, 117, 122, 0.2);
      background-color: rgba(23, 117, 122, 0.2);
    }
  }
}
.addCandidateDialog {
  .head_title {
    display: flex;
    margin-right: 40px;
    .line {
      width: 4px;
      height: 20px;
      border-radius: 4px;
      background-color: #17757a;
      margin-right: 8px;
    }

    .txt {
      color: #333333;
      font-size: 16px;
      font-weight: 600;
    }

    .search_candidate {
      display: flex;
      // 方法一
      margin-left: auto;
      /deep/.el-input {
        width: 289px;
        height: 36px;
      }
      /deep/.el-input__inner {
        width: 289px;
        height: 36px;
      }
      .search_candidate_box {
        width: 48px;
        height: 36px;
        background-color: #17757a;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        cursor: pointer;
      }
    }
  }
  .addCandidateDialog_main {
    // margin-top: 26px;
    height: 600px;
    border-top: 1px solid rgba(225, 225, 225, 1);

    .search {
      padding: 20px 0;
      border-bottom: 1px solid rgba(225, 225, 225, 1);

      .search_btn {
        ::v-deep.el-button--primary:nth-child(2) {
          background: rgba(230, 230, 230, 1) !important;
          color: rgba(124, 126, 138, 1) !important;
          border-color: rgba(230, 230, 230, 1) !important ;
        }
      }
    }

    .addCandidateDialog_main_title {
      color: #333333;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
      padding-right: 200px;
      margin-bottom: 14px;
    }

    .addCandidateDialog_main_box {
      // border-bottom: 1px solid rgba(225, 225, 225, 1);
      width: 800px;
      height: calc(100% - 200px);
      padding: 0 20px;
      overflow-y: auto;
      // border-top: 1px solid #dcdee0;
      box-sizing: border-box;

      .addCandidateDialog_main_item {
        height: 104px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid#DCDEE0;

        .left {
          display: flex;
          align-items: center;
          .check {
            width: 72px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .img_box {
            width: 72px;
            height: 74px;
            margin-right: 11px;
            .img {
              width: 100%;
              height: 100%;
              border: 4px;
            }
          }
          .info {
            height: 74px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .userName {
              font-size: 18px;
              font-weight: 600;
              color: #333333;
            }
            .shool {
              color: #17757a;
              font-size: 12px;
              font-weight: 400;
              border: 1px solid rgba(23, 117, 122, 0.2);
              padding: 3px 6px;
            }
            .else {
              font-size: 14px;
              color: #666666;
              display: flex;
              align-items: center;

              .else_line {
                width: 1px;
                height: 11px;
                background-color: #b2b2b2;
                margin: 0 8px 0 6px;
              }
            }
          }
        }

        .right {
          display: flex;
          align-items: center;
          .matching_rate {
            display: flex;
            align-items: center;
          }
          .details {
            margin-left: 44px;
            color: #17757a;
            cursor: pointer;
          }
        }
      }
    }
  }
  .pagination_box {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    .addCandidateDialog_main_title_right {
      .select {
        color: #17757a;
        margin-left: 8px;
      }
    }
  }

  .btn_list {
    display: flex;
    justify-content: center;
    font-size: 12px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid rgba(225, 225, 225, 1);
    .add {
      border-radius: 4px;
      width: 64px;
      height: 35px;
      background-color: #17757a;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #fff;
      margin-left: 34px;
    }
    .cancel {
      border-radius: 4px;
      border: 1px solid #17757a;
      width: 64px;
      height: 33px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #17757a;
    }
  }
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #fff !important;
}

.searchT {
  .ckeckbox_text {
    display: flex;
    align-items: center;
  }
  .person {
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    text-align: left;
    color: rgba(0, 0, 0, 1);
    margin-right: 60px;
  }
  .input_new {
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    margin-right: 32px;
  }
}
.table {
  margin-top: 12px;
  .table_item {
    display: flex;
    align-items: center;
    .item_checkbox {
      margin-right: 10px;
    }
  }
  .item_data {
    width: 100%;
    border-radius: 4px;
    background: #fff;
    border-radius: 4px;
    .item_top {
      padding: 14px 10px;
      display: flex;
      justify-content: space-between;
      position: relative;
      .uniqueId_number {
        top: 0px;
        right: 0;
        position: absolute;
        width: 121px;
        height: 20px;
        border-radius: 0px 4px 0px 4px;
        color: rgba(23, 117, 122, 1);
        background: rgba(230, 250, 250, 1);
        border: 1px solid rgba(217, 242, 242, 1);
        text-align: center;
        font-size: 14px;
      }
      .infoData {
        display: flex;
        align-items: center;
        img {
          width: 72px;
          height: 74px;
          border-radius: 4px;
          margin-right: 12px;
        }
        .info {
          h3 {
            font-size: 18px;
            font-weight: 500;
            line-height: 25.2px;
            cursor: pointer;
          }
          h3:hover {
            color: rgba(23, 117, 122, 1);
          }
          .schoolInfo {
            img {
              width: 16px;
              height: 16px;
            }
            padding: 2px 4px;
            display: flex;
            align-items: center;
            font-size: 12px;
            color: rgba(23, 117, 122, 1);
            border: 1px solid rgba(23, 117, 122, 0.2);
            border-radius: 2px;
            margin: 4px 0;
          }
          .experienceInfo {
            font-size: 14px;
            font-weight: 400;
            line-height: 19.6px;
            text-align: left;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
      .proRight {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        margin-right: 30px;
        .time {
          font-size: 12px;
          font-weight: 400;
          line-height: 16.8px;
          text-align: left;
          color: rgba(153, 153, 153, 1);
          margin-top: 16px;
          .person {
            padding-right: 22px;
          }
        }
      }
    }
    .item_bom {
      background: linear-gradient(
        90deg,
        rgba(0, 215, 198, 0.054) 0%,
        rgba(235, 235, 235, 0.36) 100%
      );
      display: flex;
      align-items: center;
      padding: 10px;
      font-size: 14px;
      font-weight: 400;
      line-height: 19.6px;
      border-radius: 0 0 4px 4px;

      img {
        width: 30px;
        height: 30px;
        margin-right: 4px;
      }
      .tip {
        color: rgba(23, 117, 122, 1);
        font-size: 14px;
        font-weight: 600;
        line-height: 19.6px;
        display: flex;
        align-items: center;
      }
      .company {
        display: flex;
        align-items: center;
        color: rgba(51, 51, 51, 1);
        margin-right: 40px;
      }
      .job {
        display: flex;
        align-items: center;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
  .status {
    display: flex;
    align-items: center;
    img {
      width: 76px;
      height: 60px;
    }
    span {
      color: rgba(245, 57, 57, 1);
      font-size: 12px;
      font-weight: 400;
      line-height: 16.8px;
    }
    .n {
      display: flex;
      align-items: center;
    }
  }
}
.auditingNo {
  .title {
    display: flex;
    align-items: center;
  }

  span:nth-child(1) {
    display: block;
    width: 4px;
    height: 20px;
    background: rgba(23, 117, 122, 1);
    border-radius: 4px;
    margin-right: 6px;
  }
  span:nth-child(2) {
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    color: rgba(51, 51, 51, 1);
  }
}
// ::v-deep .el-radio__inner {
//   border: 1px solid rgba(23, 117, 122, 1);
// }
// ::v-deep .el-dialog__footer {
//   .dialog-footer {
//     display: flex;
//     justify-content: center;
//   }
// }

.center {
  flex: 1;
  justify-content: flex-start;
  align-items: flex-start;

  .timeline_box {
    // margin-left: 100px;
    display: flex;
    flex-direction: column;
    //align-items: center;

    /deep/ .el-timeline {
      display: flex;
      flex-direction: column;

      .el-timeline-item {
        padding: 20px 0 0 0;
      }
    }
  }

  /deep/.el-timeline-item {
    padding: 0 !important;
  }

  /deep/ .el-timeline-item__node {
    border: 3px solid #17757a;
    box-sizing: border-box;
    background-color: #fff;
  }

  /deep/ .el-timeline-item__tail {
    border-left: 2px solid #17757a;
  }
}
/deep/.el-button.is-plain:focus,
.el-button.is-plain:hover {
  // background: #fff;
  border-color: #17757a;
  color: #17757a;
}
/deep/.el-button:focus {
  color: #17757a;
  border-color: #fff;
}
.red {
  color: rgba(250, 80, 80, 1);
  font-size: 14px;
  margin-left: 10px;
}
.green {
  color: rgba(23, 117, 122, 1);
  font-size: 14px;
  margin-left: 10px;
}
// .candidate_list_item {
//   position: relative;
//   // width: 100%;
//   // display: flex;
//   // align-items: center;
//   // justify-content: space-between;
//   // height: 110px;
//   // background-color: #fff;
//   // padding-left: 11px;
//   // margin-bottom: 15px;
//   .identification {
//     position: absolute;
//     top: 5px;
//     left: 0;
//   }

//   .left,
//   .center,
//   .right {
//     display: flex;
//     align-items: flex-end;
//   }

//   .left {
//     width: 30%;

//     .image_box {
//       margin-right: 11px;
//       width: 72px;
//       height: 74px;

//       .img {
//         width: 100%;
//         height: 100%;
//         border-radius: 4px;
//       }
//     }

//     .user_info {
//       .user_name {
//         display: flex;

//         .name {
//           font-size: 18px;
//           font-weight: 600;
//           color: #333333;
//         }
//       }
//       .xueli {
//         display: flex;
//         align-items: center;
//         padding: 2px 4px;
//         border-radius: 4px;
//         color: #17757a;
//         border: 1px solid rgba(23, 117, 122, 0.2);
//       }
//     }

//     .age {
//       font-size: 12px;
//       color: #333333;
//       margin-top: 9px;
//     }

//     .source {
//       display: flex;
//       align-items: center;
//       color: #666666;
//       font-size: 14px;
//       margin-top: 4px;

//       .source_line {
//         width: 1px;
//         height: 11px;
//         background-color: #b2b2b2;
//         margin: 0 8px 0 6px;
//       }
//     }
//   }

//   .center {
//     flex: 1;
//     justify-content: flex-start;

//     .timeline_box {
//       // margin-left: 100px;
//       display: flex;
//       flex-direction: column;
//       align-items: center;

//       /deep/ .el-timeline {
//         display: flex;
//         flex-direction: column;

//         .el-timeline-item {
//           padding: 20px 0 0 0;
//         }
//       }
//     }

//     /deep/.el-timeline-item {
//       padding: 0 !important;
//     }

//     /deep/ .el-timeline-item__node {
//       border: 3px solid #17757a;
//       box-sizing: border-box;
//       background-color: #fff;
//     }

//     /deep/ .el-timeline-item__tail {
//       border-left: 2px solid #17757a;
//     }
//   }

//   .right {
//     width: 30%;
//     height: 100%;
//     flex-flow: column;
//     justify-content: space-evenly;
//     padding-right: 76px;

//     .right_options {
//       display: flex;
//       justify-content: flex-end;
//       align-items: center;

//       .shenhe {
//         width: 88px;
//         height: 32px;
//         background: rgba(77, 146, 250, 1);
//         color: #fff;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         border: none;
//         margin-right: 14px;
//       }

//       .newsets {
//         width: 89px;
//         height: 32px;
//         border-radius: 4px;
//         border: 1px solid rgba(220, 222, 224, 1);
//         background: rgba(220, 222, 224, 1);
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         color: rgba(153, 153, 153, 1);
//       }
//       .newsets:hover {
//         border: none !important;
//       }

//       .compile {
//         border: 1px solid #17757a;
//         border-radius: 4px;
//         width: 84px;
//         height: 32px;
//         color: #17757a;
//         font-size: 14px;
//         padding: 6px 7px;
//         margin-right: 14px;
//         box-sizing: border-box;
//         text-align: center;
//         cursor: pointer;
//       }

//       .newest {
//         border: 1px solid #17757a;
//         border-radius: 4px;
//         width: 84px;
//         height: 32px;
//         color: #17757a;
//         font-size: 14px;
//         padding: 6px 7px;
//         margin-right: 14px;
//         box-sizing: border-box;
//         text-align: center;
//         cursor: pointer;
//       }

//       .details {
//         font-size: 14px;
//         color: #17757a;
//         display: flex;
//         align-items: center;
//         cursor: pointer;
//       }
//       ::v-deep.el-button--primary {
//         width: 89px;
//         height: 32px;
//         border: 1px solid rgba(23, 117, 122, 1);
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         background: #fff !important;
//         color: rgba(23, 117, 122, 1) !important;
//         margin-right: 14px;
//       }
//     }

//     .created_time {
//       color: #999999;
//       font-size: 12px;
//       display: flex;
//       flex-direction: row-reverse;
//     }
//   }
// }

.active {
  border: 1px solid #17757a;
  border-radius: 4px;
}
.fabu {
  display: flex;
  align-items: center;
  .cirle {
    width: 12px;
    height: 12px;
    border-radius: 12px;
    border: 2px solid #dcdfe6;
    background: rgba(23, 117, 122, 1);
    box-sizing: border-box;
  }
}
.inner_title {
  display: flex;
  margin-bottom: 20px;
  .inner_line {
    border: 2px solid rgba(23, 117, 122, 1);
    height: 18px;
    border-radius: 2px;
    margin-right: 10px;
  }
}
.dialog-footer {
  .button_box {
    display: flex;
    justify-content: center;
    font-size: 12px;

    .add {
      width: 64px;
      height: 33px;
      border-radius: 4px;
      background-color: #17757a;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-right: 20px;
    }

    .cancel {
      width: 64px;
      height: 33px;
      border-radius: 4px;
      border: 1px solid #17757a;
      display: flex;
      align-items: center;
      color: #17757a;
      justify-content: center;
      cursor: pointer;
    }
  }
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 80vh !important;
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 76vh !important;
  }
  .enterporise_list_input_add {
    .left {
      min-width: 38% !important;
    }
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 71vh !important;
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 78vh !important;
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 72vh !important;
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 71vh !important;
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 69vh !important;
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 60vh !important;
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 75vh !important;
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 71vh !important;
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 60vh !important;
  }
}
</style>
